const apr24 = `Pages Checked,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,116,Є2337,65,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,nationalprecision,6166,Approved,13319,02-April-2024,,,,1,Walmart,6224,Approved,04-April-2024,12293,
2,Little Hardware,6168,Approved,13361,02-April-2024,,,,2,Modern Shop,6225,Approved,04-April-2024,13438,
3,Laguna Parts & Accessories,6169,Approved,13339,02-April-2024,,,,3,Mercateo,6243,Approved,06-April-2024,13500,
4,Palm Industrial,6170,Approved,13340,02-April-2024,,,,4,Softwerk,6244,Approved,06-April-2024,13498,
5,Industrial Robot Mro,6171,Approved,13341,02-April-2024,,,,5,ROTALL,6245,Approved,06-April-2024,13486,
6,Ideal Appliance Parts,6183,Approved,13342,03-April-2024,,,,6,Eisen Hartmann,6247,Approved,06-April-2024,13490,
7,Raptor Supplies,6194,Approved,13446,03-April-2024,,,,7,Techniparts Industrial Supply,6246,Approved,06-April-2024,13492,
8,Repair Clinic,6184,Approved,13444,03-April-2024,,,,8,Kugellager Express,6251,Approved,07-April-2024,13479,
9,Raptor Supplies POL,6193,Approved,13445,03-April-2024,,,,9,Anndora,6252,Approved,07-April-2024,13496,
10,Wastebuilt,6200,Approved,13362,04-April-2024,,,,10,Nieruf,6253,Approved,07-April-2024,13495,
11,GE Appliances,6202,Approved,13371,04-April-2024,,,,11,Buerklin,6274,Approved,08-April-2024,13504,
12,Stay Online,6206,Approved,13351,04-April-2024,,,,12,Hood,6293,Approved,09-April-2024,13503,
13,Spesa Elettrica,6208,Approved,13447,04-April-2024,,,,13,Murrelektronik,6325,Approved,12-April-2024,13200,
14,toolteam24,6222,Approved,13414,04-April-2024,,,,14,Raab Karcher,6331,Approved,12-April-2024,13537,
15,Krautli,6218,Approved,13417,04-April-2024,,,,15,Schubert-Tacke,6332,Approved,12-April-2024,13538,
16,Outdoor Power Direct,6229,Approved,13378,05-April-2024,,,,16,Druckluft Fachhandel,6338,Approved,13-April-2024,13536,
17,Tandmore,6240,Approved,13465,05-April-2024,,,,17,WM Industrietechnik,6339,Approved,13-April-2024,13506,
18,Speed Way Motors,6236,Approved,13324,05-April-2024,,,,18,Exptech,6342,Approved,14-April-2024,13534,
19,JR Products,6228,Approved,13349,05-April-2024,,,,19,Lmt Trede,6343,Approved,14-April-2024,13532,
20,Voelkner,6276,Approved,13502,05-April-2024,,,,20,Febrotec,6344,Approved,14-April-2024,13529,
21,Computersalg,6248,Approved,13468,06-April-2024,,,,21,MTA Pneumatics,6378,Approved,15-April-2024,13527,
22,Repair Clinic,6249,Approved,13472,06-April-2024,,,,22,Hasler,6379,Approved,15-April-2024,13528,
23,DM SUPPLY SOURCE,6250,Approved,13457,07-April-2024,,,,23,IAS Components,6399,Approved,16-April-2024,13544,
24,Wille Electric,6257,Approved,13456,07-April-2024,,,,24,Lkwteileautodoc,6402,Approved,16-April-2024,13525,
25,IK Industry,6259,Approved,13451,07-April-2024,,,,25,Mercateo,6420,Approved,17-April-2024,13424,
26,Rowse Automation,6258,Approved,13455,07-April-2024,,,,26,Mercateo CHE,6427,Approved,17-April-2024,13511,
27,Stob-Shop,6260,Approved,13493,08-April-2024,,,,27,Mercateo Austria,6426,Approved,17-April-2024,13510,
28,Water Filters,6261,Approved,13333,08-April-2024,,,,28,Mercateo France,6456,Approved,18-April-2024,13512,
29,Azbil North America,6264,Approved,13338,08-April-2024,,,,29,Mercateo SVK,6457,Approved,18-April-2024,13499,
30,ShopBielerDruckluft,6269,Approved,13494,08-April-2024,,,,30,Technikprimus,6458,Approved,18-April-2024,13422,
31,Fluidconcept24,6271,Approved,13489,08-April-2024,,,,31,Akf-Shop,6459,Approved,18-April-2024,13448,
32,Tandmore,6275,Approved,13505,09-April-2024,,,,32,EibaboUSA,6478,Approved,19-April-2024,13541,
33,Cheapestbuy,6279,Approved,13483,09-April-2024,,,,33,Zoro US,6479,Approved,19-April-2024,13411,
34,SchlauchProfi,6290,Approved,13488,09-April-2024,,,,34,Farnell AUT,6480,Approved,19-April-2024,13459,
35,Elkoba,6291,Approved,13487,09-April-2024,,,,35,Sigma Surplus,6483,Approved,20-April-2024,13553,
36,Colamco,6283,Approved,13369,09-April-2024,,,,36,Pumpe2s4,6486,-,20-April-2024,13513,
37,Central Arizona Supply,6278,Approved,13377,09-April-2024,,,,37,Rose,6487,Approved,20-April-2024,13238,
38,S.I. Distributing Inc,6301,Approved,13014,11-April-2024,,,,38,Universal Cycles,6489,Approved,21-April-2024,13334,
39,Farm Supply Store,6298,Approved,13348,11-April-2024,,,,39,MSI Tech,6490,Approved,21-April-2024,13346,
40,Gas and Supply,6294,Approved,13316,11-April-2024,,,,40,Diamond Tool,6494,-,21-April-2024,13363,
41,Pilot Gear Online,6319,Approved,13350,12-April-2024,,,,41,Universal Tractor Co.,6495,Approved,21-April-2024,13364,
42,Banner Engineering,6315,-,13330,12-April-2024,,,,42,Breemes,6519,Approved,22-April-2024,13466,
43,All4sps,6292,Approved,13491,12-April-2024,,,,43,Sysgotec,6518,Approved,22-April-2024,13470,
44,Piel Schlembach,6303,Approved,13467,12-April-2024,,,,44,bmx ray,6531,Approved,23-April-2024,13564,
45,Schraubenhimmel,6304,Approved,13514,12-April-2024,,,,45,FlukeBiomedical,6536,Approved,23-April-2024,13569,
46,MTEC Shop,6323,Approved,13535,12-April-2024,,,,46,DavisMedicalElectronics,6533,Approved,23-April-2024,13567,
47,CBT,6327,Approved,13353,12-April-2024,,,,47,Marquis,6558,Approved,24-April-2024,13575,
48,Contrel,6334,Approved,13526,13-April-2024,,,,48,DirectMedImaging,6559,Approved,24-April-2024,13561,
49,Autonorma,6333,Approved,13530,13-April-2024,,,,49,Tease Solutions,6560,Approved,24-April-2024,13463,
50,Server Supply,6329,Approved,13355,13-April-2024,,,,50,German Electronics,6586,Approved,25-April-2024,13571,
51,Pillunat,6337,Approved,13523,14-April-2024,,,,51,Ludwig Meister,6587,Approved,25-April-2024,13583,
52,Pacific Power Group,6328,Approved,13356,14-April-2024,,,,52,Industrial Stores,6588,Approved,25-April-2024,13590,
53,Pif Parts,6365,Approved,13775,15-April-2024,,,,53,Ges Repair,6600,Approved,26-April-2024,13609,
54,Part Simple,6371,Approved,13358,15-April-2024,,,,54,industrialautomationco,6599,Approved,26-April-2024,13610,
55,Tek4ufast,6387,Approved,13367,16-April-2024,,,,55,Vogel DruckLuft,6598,Approved,26-April-2024,13616,
56,Omni Outdoor Livin,6381,Approved,13373,16-April-2024,,,,56,Jutger Online,6620,Approved,27-April-2024,13582,
57,Mercateo GBR,6393,Approved,13549,16-April-2024,,,,57,Honnens,6622,Approved,27-April-2024,13603,
58,Scientific Instrument Parts,6397,Approved,13344,17-April-2024,,,,58,Automatik Shop,6621,Approved,27-April-2024,13460,
59,RV Part Shop,6398,Approved,13372,17-April-2024,,,,59,Otto Aschmann,6632,Approved,28-April-2024,13461,
60,Filter Recon,6423,Approved,13551,17-April-2024,,,,60,Wiautomation US,6641,Approved,28-April-2024,13611,
61,Walter Wood,6414,Approved,13380,17-April-2024,,,,61,Conrad SWE,6640,-,28-April-2024,13617,
62,4TecDirect,6424,Approved,13391,18-April-2024,,,,62,FrontierImaging,6627,Approved,28-April-2024,13636,
63,Products for automation,6446,Approved,13392,18-April-2024,,,,63,Parts Source,6646,Approved,29-April-2024,13637,
64,Controls Central,6447,Approved,13557,18-April-2024,,,,64,HenryScheinMedical,6667,-,30-April-2024,13572,
65,GESCAN,6448,Approved,13556,18-April-2024,,,,65,HenryScheinDental,6668,-,30-April-2024,13644,
66,HPE automation,6450,Approved,13385,18-April-2024,,,,,,,,,,
67,Landscaper Pro,6467,Approved,13386,19-April-2024,,,,,,,,,,
68,DistrelecBiz,6472,-,13421,19-April-2024,,,,,,,,,,
69,Krone Filtertechnik,6477,Approved,13524,19-April-2024,,,,,,,,,,
70,Camtelligence,6471,Approved,13519,19-April-2024,,,,,,,,,,
71,Agropartner OHB,6468,Approved,13521,21-April-2024,,,,,,,,,,
72,Hansa-Flex POL,6492,Approved,12712,21-April-2024,,,,,,,,,,
73,Afzhan,6488,Approved,12705,21-April-2024,,,,,,,,,,
74,Otec-Industry,6485,Approved,12670,21-April-2024,,,,,,,,,,
75,Direct Hydro,6484,Approved,12601,21-April-2024,,,,,,,,,,
76,eEuroparts,6482,Approved,13022,21-April-2024,,,,,,,,,,
77,IFM Russia,6481,Approved,12608,21-April-2024,,,,,,,,,,
78,Osd-Schenck,6493,Approved,13137,21-April-2024,,,,,,,,,,
79,VOITELUAINEKAUPPA,6502,Approved,13420,22-April-2024,,,,,,,,,,
80,EGC Supply,6449,Approved,13398,22-April-2024,,,,,,,,,,
81, Tacoma Screw,6444,Approved,13388,22-April-2024,,,,,,,,,,
82,Kraemer Ersatzteile,6506,Approved,13464,22-April-2024,,,,,,,,,,
83,As Elektrobedarf,6510,Approved,13481,22-April-2024,,,,,,,,,,
84,Tameson,6509,Approved,13482,22-April-2024,,,,,,,,,,
85,Clinical Imaging Systems,6523,Approved,13566,23-April-2024,,,,,,,,,,
86,Theo Schrauben,6522,Approved,13469,23-April-2024,,,,,,,,,,
87,Probo Medical,6525,Approved,13577,23-April-2024,,,,,,,,,,
88,Block Imaging,6521,Approved,13563,23-April-2024,,,,,,,,,,
89,Suntronix Medical Imaging,6527,Approved,13562,23-April-2024,,,,,,,,,,
90,Image Technology Consulting,6550,Approved,13573,24-April-2024,,,,,,,,,,
91,Avante Health Solution,6530,Approved,13589,24-April-2024,,,,,,,,,,
92,Voelkner,6552,Approved,13584,24-April-2024,,,,,,,,,,
93,GESCAN,6553,Approved,13586,24-April-2024,,,,,,,,,,
94,Parts Source,6547,Approved,13594,24-April-2024,,,,,,,,,,
95,Technikprimus,6551,Approved,13576,24-April-2024,,,,,,,,,,
96,Variware,6529,Approved,13591,24-April-2024,,,,,,,,,,
97,TTG Imaging Solutions,6532,Approved,13585,24-April-2024,,,,,,,,,,
98,Buyrexroth,6577,Approved,13597,25-April-2024,,,,,,,,,,
99,Apeltrath & Rundt,6576,Approved,13598,25-April-2024,,,,,,,,,,
100,Ebmia,6574,Approved,13599,25-April-2024,,,,,,,,,,
101,AUTOMATICA,6573,Approved,13601,25-April-2024,,,,,,,,,,
102,Acme Controls,6570,Approved,13588,25-April-2024,,,,,,,,,,
103,RS&A Oncology Parts,6535,Approved,13578,25-April-2024,,,,,,,,,,
104,IAS Components,6607,Approved,13615,26-April-2024,,,,,,,,,,
105,Seltec,6606,Approved,13619,26-April-2024,,,,,,,,,,
106,Norelem DEU,6602,-,13480,26-April-2024,,,,,,,,,,
107,HORIZON,6609,Approved,13606,26-April-2024,,,,,,,,,,
108,Vision Supplies Europe,6608,Approved,13614,26-April-2024,,,,,,,,,,
109,Conrad AUT,6594,-,13548,27-April-2024,,,,,,,,,,
110,Conrad SVN,6618,-,13543,27-April-2024,,,,,,,,,,
111,Conrad SVK,6619,-,13620,27-April-2024,,,,,,,,,,
112,DKL Kugellager Shop,6623,Approved,13605,28-April-2024,,,,,,,,,,
113,Wiautomation Can,6628,Approved,13613,28-April-2024,,,,,,,,,,
114,Ceytron,6659,-,13635,30-April-2024,,,,,,,,,,
115,Zajadacz,6666,-,13633,30-April-2024,,,,,,,,,,
116,Brd. Klee,6661,Approved,13634,30-April-2024,,,,,,,,,,`;

const may24 = `Pages Checked,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,128,Є2717,79,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,Unielektro,6672,Approved,13631,01-May-2024,,,,1,Impexron,6681,Approved,01-May-2024,13627,
2,Alibaba DEU,6671,Approved,13518,01-May-2024,,,,2,merales,6680,Approved,01-May-2024,13624,
3,Schaeffler AUT,6673,Approved,13632,01-May-2024,,,,3,Power Parts Pro,6679,Approved,01-May-2024,13626,
4,Klauke DEU,6674,Approved,13628,02-May-2024,,,,4,Care 4 Cows,6708,-,02-May-2024,13664,
5,Kühntec,6677,Approved,13622,02-May-2024,,,,5,Winkler,6707,Approved,02-May-2024,13672,
6,Germany Bearing,6676,Approved,13625,02-May-2024,,,,6,StutsMans,6706,-,02-May-2024,12815,
7,BTN de Haas,6697,Approved,13677,03-May-2024,,,,7,Sano,6732,-,03-May-2024,13674,
8,CPS Veneto,6696,Approved,13673,03-May-2024,,,,8,Agrarbedarf,6733,-,03-May-2024,13670,
9,August Thoms,6690,Approved,13675,03-May-2024,,,,9,Eimermacher,6734,Approved,03-May-2024,13676,
10,Hofmeister & Meincke,6689,Approved,13671,03-May-2024,,,,10,Blattin,6741,-,04-May-2024,13669,
11,Dimira,6682,Approved,13629,03-May-2024,,,,11,Gards Service,6742,-,04-May-2024,13666,
12,Feld und Stall,6724,Approved,13668,04-May-2024,,,,12,Frischdienst Redeker,6743,Approved,04-May-2024,13646,
13,Wischmopps,6719,Approved,13648,04-May-2024,,,,13,Agrologic,6744,-,04-May-2024,13654,
14,Niendorf Reinigungsmittel,6730,Approved,13649,04-May-2024,,,,14,AgriServiceJeuken,6745,-,05-May-2024,13659,
15,Aaronclean,6718,Approved,13647,04-May-2024,,,,15,Aprofi Group,6746,-,05-May-2024,13658,
16,Belt Agri,6739,Approved,13653,05-May-2024,,,,16,Estermann Warenhandel,6747,-,05-May-2024,13660,
17,Farmshop,6738,Approved,13652,05-May-2024,,,,17,UTS Agrar,6748,-,05-May-2024,13661,
18,Arga-Gabifix,6735,Approved,13651,05-May-2024,,,,18,Sternet,6774,-,06-May-2024,13623,
19,Dojarki,6734,Approved,13650,05-May-2024,,,,19,Mercateo BEL,6770,-,06-May-2024,13680,
20,Galvet,6740,Approved,13655,05-May-2024,,,,20,Faie,6767,Approved,06-May-2024,13645,
21,Agri-Service Walluch,6756,Approved,13656,06-May-2024,,,,21,LevyEps,6810,-,08-May-2024,13381,
22, Agri Care Trade,6763,Approved,13665,06-May-2024,,,,22,elektrowelt zwickau,6818,-,08-May-2024,13754,
23,Anax Group,6762,Approved,13657,06-May-2024,,,,23,RandysHardware,6814,-,08-May-2024,13395,
24,Indramat USA,6795,Approved,13746,07-May-2024,,,,24,MKRittenhouse,6811,-,08-May-2024,13394,
25,Elektrohandel Prem,6794,Approved,13746,07-May-2024,,,,25,MylittleSalesman,6829,Approved,09-May-2024,13760,
26,The Dryer Doctors,6788,Approved,13310,07-May-2024,,,,26,Radwell,6828,Approved,09-May-2024,13558,
27,Printspareparts,6798,Approved,13737,07-May-2024,,,,27,Midwestagsystems,6826,Approved,09-May-2024,13781,
28,Cherry Group,6797,Approved,13743,07-May-2024,,,,28,Freudenberg,6848,-,12-May-2024,12594,
29,Mands Machinery,6813,Approved,13779,08-May-2024,,,,29,Lily Bearing,6852,-,12-May-2024,13757,
30,Sähkönumerot,6809,Approved,13699,08-May-2024,,,,30,Agronetto,6851,-,12-May-2024,13755,
31,Shortec,6808,Approved,13732,08-May-2024,,,,31,StutsMans,6854,Approved,13-May-2024,-,Urgent Fix was Required
32,Salem Farm Supply,6823,Approved,13766,09-May-2024,,,,32,4MyCar,6886,Approved,13-May-2024,13775,
33,RSD Electronic,6819,Approved,13773,09-May-2024,,,,33,Inter Technika,6888,-,13-May-2024,13772,
34,Industrial Material Center,6817,Approved,13778,09-May-2024,,,,34,Mercateo,6915,-,14-May-2024,13807,
35,Bizonagro,6821,Approved,13761,09-May-2024,,,,35,Farnell FR,6918,Approved,14-May-2024,13795,
36,4TBazar,6847,Approved,13776,11-May-2024,,,,36,Farnell EE,6919,Approved,14-May-2024,13796,
37,Wildberries UZK,6846,Approved,13777,11-May-2024,,,,37,Farnell CZ,6922,Approved,14-May-2024,13797,
38,Onrion LLC,6832,Approved,13774,11-May-2024,,,,38,VrReinigungstechnik,6885,Approved,13-May-2024,13187,
39,Bürklin,6845,Approved,13782,11-May-2024,,,,39,Farnell LVA ,6943,Approved,15-May-2024,13798,
40, Impexron DNK,6830,Approved,13694,11-May-2024,,,,40,Farnell SVK,6944,Approved,15-May-2024,13799,
41,RembConnect,6843,Approved,13763,11-May-2024,,,,41,Farnell LTU,6945,Approved,15-May-2024,13804,
42,Impexron FRA,6840,Approved,13686,12-May-2024,,,,42,TME,6975,-,16-May-2024,13835,
43,Regro,6827,Approved,13745,12-May-2024,,,,43,Blackhawk Supply,6981,Approved,16-May-2024,13813,
44,OZAgroParts,6824,Approved,13762,12-May-2024,,,,44,Jacob,6982,-,16-May-2024,13828,
45,WBParts,6850,Approved,13767,12-May-2024,,,,45,Best4Automation,6983,Approved,16-May-2024,13829,
46,Kernal Market,6849,Approved,13759,12-May-2024,,,,46,1877ForParts,7007,Approved,17-May-2024,13836,
47,Robertshaw,6804,Approved,13684,12-May-2024,,,,47,URI,7008,Approved,17-May-2024,13815,
48,Kendall Electric,6801,Approved,13683,13-May-2024,,,,48,Alles Mit Stecker,7006,Approved,17-May-2024,13830,
49,Stokker LTU,6837,Approved,13768,13-May-2024,,,,49,RDM Parts,7019,Approved,18-May-2024,13832,
50,Famaga UAE,6889,Approved,13702,13-May-2024,,,,50,MaasAutomation,7020,Approved,18-May-2024,13834,
51,Loyal,6914,Approved,13695,14-May-2024,,,,51,THC,7021,Approved,18-May-2024,13838,
52,Teval Elektronika,6913,Approved,13789,14-May-2024,,,,52,Farnell DE,7022,-,19-May-2024,13823,
53,Pepperl-Fuchs,6912,Approved,13800,14-May-2024,,,,53,Traydon,7023,Approved,19-May-2024,13826,
54,Druckluft Fachhandel AUT,6910,Approved,13802,14-May-2024,,,,54,Sp_Recambios,7024,Approved,19-May-2024,13822,
55,Stercontrol,6908,Approved,13803,15-May-2024,,,,55,Apeltrath Rundt,7082,Approved,23-May-2024,13883,
56,Elbz,6931,Approved,13744,15-May-2024,,,,56,Landefeld,7081,-,23-May-2024,13882,
57,Kaskad,6934,Approved,13742,15-May-2024,,,,57,ElektroMax24,7075,-,23-May-2024,13833,
58,Finktec,6844,Approved,13663,15-May-2024,,,,58,MRO PT,7029,-,20-May-2024,13846,
59,Tanrud,6958,Approved,13688,16-May-2024,,,,59,KSC Direct,7031,-,20-May-2024,13847,
60,Petro Mineral,6959,Approved,13691,16-May-2024,,,,60,Industrial Automation Parts,7030,-,20-May-2024,13852,
61,Damen Schelde Parts,6957,Approved,13693,16-May-2024,,,,61,Bernardsanders,7104,Approved,24-May-2024,13865,
62,Onninen OY,6965,Approved,13692,16-May-2024,,,,62,Rodavigo,7103,Approved,24-May-2024,13866,
63,Promtek,6992,Approved,13687,17-May-2024,,,,63,KuhfussOnline,7105,-,24-May-2024,13878,
64,Scandinavian Medical,6994,Approved,13849,17-May-2024,,,,64,newark,7109,-,25-May-2024,13870,
65,OnlyMed Imaging Solutions,6996,Approved,13850,17-May-2024,,,,65,Farnell IRL,7108,-,25-May-2024,13841,
66,Sonepar FRA,6995,Approved,13706,17-May-2024,,,,66,EECO,7107,-,25-May-2024,13876,
67,Impexron MKD,6969,Approved,13714,17-May-2024,,,,67,RS Delivers USA,7112,-,26-May-2024,13887,
68,Mentavill,6993,Approved,13682,18-May-2024,,,,68,RSDelivers BRA,7111,-,26-May-2024,13871,
69,Impexron GBR,6987,Approved,13720,18-May-2024,,,,69,PLC-City,7110,-,26-May-2024,13839,
70,MVI SA FR,6961,Approved,13689,18-May-2024,,,,70,Radwell,7125,-,27-May-2024,13809,
71,My TV Shop,6999,Approved,13831,18-May-2024,,,,71,RS Online DEU,7128,Approved,27-May-2024,13824,
72,Siderus,6976,Approved,13696,18-May-2024,,,,72,Radwell UK,7126,-,27-May-2024,13810,
73,NTN SNR,7009,Approved,13718,19-May-2024,,,,73,RSOnline PRT,7148,Approved,28-May-2024,13820,
74,FilFar,7010,Approved,13719,19-May-2024,,,,74,RSOnline CH,7149,Approved,28-May-2024,13825,
75,Transpoint,7012,Approved,13721,19-May-2024,,,,75,Centro,7165,Approved,29-May-2024,13919,
76,BUPC,7013,Approved,13722,19-May-2024,,,,76,SOS SK,7164,Approved,29-May-2024,13793,
77,Robertson Equipment,7015,Approved,13724,19-May-2024,,,,77,Handel Pro,7188,-,30-May-2024,13780,
78,Meyle,7017,Approved,13729,19-May-2024,,,,78,ETRA Fin,7189,-,30-May-2024,13709,
79,Lektronix,7018,Approved,13712,19-May-2024,,,,79,Voelkner,7213,-,31-May-2024,13922,
80,Pgt Truck Parts,7052,Approved,13844,22-May-2024,,,,,,,,,,
81,Comtt,6954,Approved,13771,22-May-2024,,,,,,,,,,
82,Sklep Rolniczy,7047,Approved,13859,22-May-2024,,,,,,,,,,
83,GRUPA MARAT,7051,Approved,13856,22-May-2024,,,,,,,,,,
84,PLC Sweden,7050,Approved,13857,22-May-2024,,,,,,,,,,
85,WEB PARTS,7049,Approved,13858,22-May-2024,,,,,,,,,,
86,Bauportal24h,7072,Approved,13862,23-May-2024,,,,,,,,,,
87,MOTION PARTS,7053,Approved,13794,23-May-2024,,,,,,,,,,
88,Sotek,7045,Approved,13845,23-May-2024,,,,,,,,,,
89,Otec,7025,Approved,13730,20-May-2024,,,,,,,,,,
90,Onninen NOR,7027,Approved,13716,20-May-2024,,,,,,,,,,
91,Eriks LUX,7086,-,13893,24-May-2024,,,,,,,,,,
92,REIFF Technische Produkte,7080,Approved,13900,24-May-2024,,,,,,,,,,
93,Go Glas,7087,Approved,13886,24-May-2024,,,,,,,,,,
94,Meltas Tedarik,7096,Approved,13726,25-May-2024,,,,,,,,,,
95,Lamb,7088,Approved,13897,25-May-2024,,,,,,,,,,
96,Lektronix DEU,7079,Approved,13739,25-May-2024,,,,,,,,,,
97,Keller & Kunz AG,7042,Approved,13738,25-May-2024,,,,,,,,,,
98,Niehues,7083,Approved,13899,25-May-2024,,,,,,,,,,
99,Hansa-Flex,7084,Approved,13898,25-May-2024,,,,,,,,,,
100,Leise,7085,Approved,13896,25-May-2024,,,,,,,,,,
101,Eriks,7095,Approved,13885,26-May-2024,,,,,,,,,,
102,Farm Parts Store,7106,Approved,13888,26-May-2024,,,,,,,,,,
103,Misumi,7101,Approved,13881,26-May-2024,,,,,,,,,,
104,Eriks FRA,7097,Approved,13894,26-May-2024,,,,,,,,,,
105,Trade Bearings DEU,7065,Approved,13715,26-May-2024,,,,,,,,,,
106,Katiks,7069,Approved,13731,26-May-2024,,,,,,,,,,
107,SBN Wälzlager,7066,Approved,13713,26-May-2024,,,,,,,,,,
108,KahmannEllerbrock,7074,-,13861,27-May-2024,,,,,,,,,,
109,Ozhat,7036,Approved,13707,27-May-2024,,,,,,,,,,
110,adj_ditec,7054,Approved,13710,27-May-2024,,,,,,,,,,
111,Acme Controls,7135,Approved,13816,28-May-2024,,,,,,,,,,
112,FAMAGA CHE,7133,Approved,13908,28-May-2024,,,,,,,,,,
113,Radiomag,7138,Approved,13904,28-May-2024,,,,,,,,,,
114,LawnMowerPartsOutlet,7117,Approved,13891,29-May-2024,,,,,,,,,,
115,Rexbo,7116,Rejected (Protected Site),13880,29-May-2024,,,,,,,,,,
116,Misumi GBR,7124,Approved,13784,29-May-2024,,,,,,,,,,
117,Taimco,7162,Approved,13917,29-May-2024,,,,,,,,,,
118,PowerTech Controls,7158,Approved,13915,29-May-2024,,,,,,,,,,
119,MSI Viking,7159,Approved,13916,29-May-2024,,,,,,,,,,
120,Fully Automation,7160,Approved,13920,29-May-2024,,,,,,,,,,
121,Ventile24,7153,Approved,13868,30-May-2024,,,,,,,,,,
122,PARTS HVAC,7163,Approved,13901,30-May-2024,,,,,,,,,,
123,KirbyRisk,7141,Approved,13851,30-May-2024,,,,,,,,,,
124,Tinex,7187,-,13733,31-May-2024,,,,,,,,,,
125,Agrar Express,7173,-,13869,31-May-2024,,,,,,,,,,
126,Controls Central,7174,-,13903,31-May-2024,,,,,,,,,,
127,Rittal,7181,-,13728,31-May-2024,,,,,,,,,,
128,Bauer Nord,7191,-,13756,31-May-2024,,,,,,,,,,`;

const jun24 = `Pages Checked,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,103,Ð„1909.5,49,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,Control Technology,7180,Rejected,13740,03-June-2024,,,,1,IK Industry,7233,-,03-June-2024,13921,
2,PC24,7176,Approved,13864,03-June-2024,,,,2,Kaufland,7261,-,04-June-2024,13931,
3,Binder USA,7170,Approved,13914,03-June-2024,,,,3,777Parts,7282,-,05-June-2024,13941,
4,Parker USA,7192,Approved,12738,03-June-2024,,,,4,Messicks,7298,-,06-June-2024,13954,
5,FPE Automation,7250,Approved,13950,04-June-2024,,,,5,Tehnoprostor,7351,Approved,10-June-2024,13978,
6,OEM-Parts,7245,Approved,13934,04-June-2024,,,,6,Bobcat DEU,7350,Approved,10-June-2024,13977,
7,Overhead Door Parts Online,7248,Approved,13948,04-June-2024,,,,7,RSOnline AUT,7378,Approved,11-June-2024,12973,
8,Green Gaskets,7247,Approved,13951,04-June-2024,,,,8,WiAutomation JPN,7450,Approved,13-June-2024,13980,
9,Power-House Electrical Supply,7244,Approved,12809,04-June-2024,,,,9,RS Online NLD,7451,Approved,15-June-2024,14003,
10,Tektite,7243,Approved,12737,04-June-2024,,,,10,RS Online HUN,7452,Approved,15-June-2024,14005,
11,Walterscheid / GKN,7221,Approved,10059,05-June-2024,,,,11,RS Online Kor,7496,Approved,19-June-2024,14034,I Updated These 30 RS Online Pages in One Ticket (Both Source & YML File).
12,Construction Equipment Guide,7220,Approved,11748,05-June-2024,,,,12,RS Online AUT,7496,Approved,19-June-2024,14034,-
13,Steyr,7217,Approved,12151,05-June-2024,,,,13,RS Online AUS,7496,Approved,19-June-2024,14034,-
14,Logic,7215,Approved,13134,05-June-2024,,,,14,RS Online CH,7496,Approved,19-June-2024,14034,-
15,Tirendo,7216,Approved,13162,05-June-2024,,,,15,RS Online CZ,7496,Approved,19-June-2024,14034,-
16,Inlinefilters,7283,Approved,13952,06-June-2024,,,,16,RS Online ID,7496,Approved,19-June-2024,14034,-
17,Werny,7263,Approved,13940,06-June-2024,,,,17,RS Online SE,7496,Approved,19-June-2024,14034,-
18,Ahlsell FIN,7264,Approved,13933,06-June-2024,,,,18,RS Online MYS,7496,Approved,19-June-2024,14034,-
19,KÃ¤rcher Center MÃ¼ller,7281,Approved,12846,06-June-2024,,,,19,RS Online NO,7496,Approved,19-June-2024,14034,-
20,Power Equipment Direct,7276,Approved,12764,06-June-2024,,,,20,RS Online PL,7496,Approved,20-June-2024,14034,-
21,Wiautomation USA,7312,Approved,13966,07-June-2024,,,,21,RS Online SG,7496,Approved,20-June-2024,14034,-
22,Murrelektronik,7307,Approved,13963,07-June-2024,,,,22,RS Online TH,7496,Approved,20-June-2024,14034,-
23,Aftermarket Express,7309,Approved,13959,07-June-2024,,,,23,RS Online TR,7496,Approved,20-June-2024,14034,-
24,Q-Parts24,7310,Approved,13969,07-June-2024,,,,24,RS Online UK,7496,Approved,20-June-2024,14034,-
25,Alles Mit Stecker,7311,Approved,13970,07-June-2024,,,,25,RS Online DE,7496,Approved,21-June-2024,14034,-
26,Elektroradar,7314,Approved,13960,07-June-2024,,,,26,RS Online CHN,7496,Approved,21-June-2024,14034,-
27,L Comp,7275,Approved,13947,07-June-2024,,,,27,RS Online JP,7496,Approved,21-June-2024,14034,-
28,Bane-Welker Equipment,7318,Approved,13955,08-June-2024,,,,28,RS Online BE,7496,Approved,22-June-2024,14034,-
29,Factory Supply Outlet,7317,Approved,13956,08-June-2024,,,,29,RS Online DK,7496,Approved,22-June-2024,14034,-
30, Reliable Aftermarket Parts,7305,Approved,13962,08-June-2024,,,,30,RS Online ES,7496,Approved,22-June-2024,14034,-
31,WIAUTOMATION JPN,7324,Approved,13965,08-June-2024,,,,31,RS Online FR,7496,Approved,22-June-2024,14034,-
32,Wiautomation,7315,Approved,13964,08-June-2024,,,,32,RS Online HK,7496,Approved,22-June-2024,14034,-
33, Belfa Makine,7308,Approved,10581,09-June-2024,,,,33,RS Online HU,7496,Approved,22-June-2024,14034,-
34,Electric Automation Network,7270,Approved,13863,09-June-2024,,,,34,RS Online IE,7496,Approved,22-June-2024,14034,-
35,GreenDozer,7214,Approved,12777,09-June-2024,,,,35,RS Online IT,7496,Approved,22-June-2024,14034,-
36,Apex Industrial Automation,7229,Approved,12767,09-June-2024,,,,36,RS Online NL,7496,Approved,22-June-2024,14034,-
37,MBO Osswald,7232,Approved,10588,09-June-2024,,,,37,RS Online TW,7496,Approved,22-June-2024,14034,-
38,Konnect Market,7048,Approved,13741,10-June-2024,,,,38,RS Online US,7496,Approved,23-June-2024,14034,-
39,Medias Schaeffler US,7035,Approved,13708,10-June-2024,,,,39,RS Online CA,7496,Approved,23-June-2024,14034,-
40,Radward,7034,Approved,13725,10-June-2024,,,,40,RS Online MX,7496,Approved,23-June-2024,14034,-
41,Tipteh,7033,Approved,13734,10-June-2024,,,,41,0815 DEU,7574,Approved,25-June-2024,14025,
42,Arcus Dichtelemente,7260,Approved,13942,10-June-2024,,,,42,Amazon Mex,7589,Approved,26-June-2024,13814,
43,RS Delivers Brazail,7366,Approved,13973,11-June-2024,,,,43,Surplus Select,7590,Approved,26-June-2024,14043,
44,Raab Karcher,6678,Approved,13621,11-June-2024,,,,44,NDetal RUS,7591,Approved,26-June-2024,14081,
45,RSDelivers Croatia,6656,-,13602,11-June-2024,,,,45,WM Industreitechnik,7605,Approved,27-June-2024,13449,
46,Austral International Co.,6429,Approved,13384,11-June-2024,,,,46, IFM Deu,7604,Approved,27-June-2024,14035,
47, Dillon Supply,6430,Approved,13382,11-June-2024,,,,47,Mercateo,7630,-,29-June-2024,14060,
48,Prematic,7389,Approved,13983,12-June-2024,,,,48,FedernShop,7631,-,29-June-2024,14106,
49,Wiautomation CAN,7383,Approved,13979,12-June-2024,,,,49,ESKC,7632,-,29-June-2024,14042,
50,Rexbo,7116,Approved,13880,12-June-2024,,,,,,,,,,
51,Werthenbach,7147,Approved,13884,12-June-2024,,,,,,,,,,
52,Zainab Supplies,7414,Approved,13987,12-June-2024,,,,,,,,,,
53,Inaserv DEU,7416,Approved,13995,13-June-2024,,,,,,,,,,
54,Factorymaterial USA,7413,Approved,13990,13-June-2024,,,,,,,,,,
55,Buyindustrialcomponents USA,7415,Approved,13992,13-June-2024,,,,,,,,,,
56,Lefeld DEU,7417,Approved,13997,13-June-2024,,,,,,,,,,
57,TR-Solution,7057,Approved,13711,13-June-2024,,,,,,,,,,
58,Kone Partsview Spares,7421,Approved,13989,15-June-2024,,,,,,,,,,
59,Rexel UK,7422,Approved,13996,15-June-2024,,,,,,,,,,
60,Kone Parts USA,7423,Approved,13999,15-June-2024,,,,,,,,,,
61,Ubuy-Brazil,7424,Approved,13974,15-June-2024,,,,,,,,,,
62,DKL Kugellager Shop,7437,Approved,14014,15-June-2024,,,,,,,,,,
63,RS Online CZE,7440,Approved,14004,15-June-2024,,,,,,,,,,
64,O'Reilly Auto Parts,7444,Approved,12323,15-June-2024,,,,,,,,,,
65,Cheapestbuy,7446,Approved,14022,15-June-2024,,,,,,,,,,
66,Wiautomation ITA,7447,Approved,14021,15-June-2024,,,,,,,,,,
67,Klocke-Antrieb DEU,7449,Approved,13993,15-June-2024,,,,,,,,,,
68,SparePartsNow,7448,Approved,14023,15-June-2024,,,,,,,,,,
69,HMS Elektrotechnik,7479,Approved,14031,18-June-2024,,,,,,,,,,
70,WMV-Dresden,7475,Approved,14029,18-June-2024,,,,,,,,,,
71,Igus DEU,7431,Approved,13994,18-June-2024,,,,,,,,,,
72,Ebora,6953,Approved,13705,18-June-2024,,,,,,,,,,
73,Wurth,6929,Approved,13747,18-June-2024,,,,,,,,,,
74,Siemens Mall,7487,Approved,13991,19-June-2024,,,,,,,,,,
75,Kendall Electric,7486,Approved,14041,19-June-2024,,,,,,,,,,
76,Conrad NLD,6884,Approved,13785,22-June-2024,,,,,,,,,,
77,Milacron,6859,Approved,13764,22-June-2024,,,,,,,,,,
78,Conrad CZE,6713,Approved,13412,22-June-2024,,,,,,,,,,
79,AWC Wire,7028,Approved,13701,22-June-2024,,,,,,,,,,
80,Conrad ITA,7172,Approved,13855,22-June-2024,,,,,,,,,,
81,Straschu,6790,Approved,13681,22-June-2024,,,,,,,,,,
82,uBuy US,7286,Approved,13023,23-June-2024,,,,,,,,,,
83,We make a price,6842,Approved,13769,23-June-2024,,,,,,,,,,
84,Nordparts,6793,Approved,13677,23-June-2024,,,,,,,,,,
85,Flix Parts,7534,Approved,14037,23-June-2024,,,,,,,,,,
86,Asendorf Hydraulik DEU,7566,Approved,14075,25-June-2024,,,,,,,,,,
87,ProfiShop,7588,Approved,14073,25-June-2024,,,,,,,,,,
88,DKL Kugellager Shop,7550,Approved,14074,25-June-2024,,,,,,,,,,
89,Alfa Hydraulics,5203,Approved,12626,25-June-2024,,,,,,,,,,
90,SCG Supplies GBR,7573,Approved,14082,25-June-2024,,,,,,,,,,
91,Conrad CHE,7561,Approved,14070,25-June-2024,,,,,,,,,,
92,Flowtrend USA,7572,Approved,14089,25-June-2024,,,,,,,,,,
93,Michele Caroli ITA,7594,Approved,14093,27-June-2024,,,,,,,,,,
94,Traydon Supplies,7593,Approved,14000,27-June-2024,,,,,,,,,,
95,Servua RUS,7592,Approved,14079,27-June-2024,,,,,,,,,,
96,Crusher Consumables Limited GBR,7587,Approved,14078,27-June-2024,,,,,,,,,,
97,Q Club RUS,7624,Approved,14112,28-June-2024,,,,,,,,,,
98,Kuhn SVN,7622,Approved,14111,28-June-2024,,,,,,,,,,
99,Farnell LTU,7617,-,14055,28-June-2024,,,,,,,,,,
100,Farnell LVA,7621,-,14057,28-June-2024,,,,,,,,,,
101, Farnell SVK,7616,-,14056,29-June-2024,,,,,,,,,,
102,IT Automationparts ITA,7629,Approved,14114,29-June-2024,,,,,,,,,,
103,Farnell ROU,7623,-,14058,29-June-2024,,,,,,,,,,`;

const jul24 = `c,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,161,Є2916.5,73,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,MRO Supply,7711,Approved,14147,04-July-2024,,,,1,ThinkflowVerkkokauppa,7689,Approved,03-July-2024,14113,
2,BdiExpress,7709,Approved,14146,04-July-2024,,,,2,TVH,7688,Approved,03-July-2024,14128,
3,Boie,7708,Approved,14137,05-July-2024,,,,3,Imperial Supplies,7744,Approved,06-July-2024,8852,
4,RS Online CHE,7661,Approved,14119,05-July-2024,,,,4,PLC Warehouse,7720,Approved,04-July-2024,12998,
5,ludwig-meister,7718,Approved,14130,05-July-2024,,,,5,Osiander,7713,Approved,04-July-2024,14094,
6,Elektronetshop,7741,Approved,14150,06-July-2024,,,,6,Elektrotools,7719,Approved,04-July-2024,14151,
7,Electric Automation Network,7706,Approved,14134,06-July-2024,,,,7,Adams Elevator,7742,Approved,06-July-2024,8215,
8,Industry-Electronics DEU,7701,Approved,14131,06-July-2024,,,,8,WazCar,7740,Approved,06-July-2024,12885,
9,Alfaelektro,7758,Approved,14157,07-July-2024,,,,9,CzesciNarzedziabaxo,7739,Approved,06-July-2024,12703,
10,Eurofluid CZE,7757,Approved,14169,07-July-2024,,,,10,China CN,7738,Approved,06-July-2024,12669,
11,Autoteile Teufel,7752,Approved,14148,07-July-2024,,,,11,Distrelec BIZ,7750,Approved,07-July-2024,14032,
12,Aliexpress DEU,7751,Approved,14098,07-July-2024,,,,12,Distrelec CHE,7750,Approved,07-July-2024,14032,
13,Keep Supply,7766,Approved,14175,09-July-2024,,,,13,Mercateo DE,7749,Approved,07-July-2024,14116,
14,RS Online POL,7755,Approved,14173,09-July-2024,,,,14,Mercateo POL,7748,Approved,07-July-2024,14099,
15,FSAS,7579,Approved,14091,09-July-2024,,,,15,Mercateo CHE,7747,Approved,07-July-2024,13972,
16,Nomo,7774,Approved,14168,09-July-2024,,,,16,Mercateo AUT,7746,Approved,07-July-2024,13786,
17,PLC TRADE ABB,7531,Approved,14120,08-July-2024,,,,17,Conrad,7793,Approved,09-July-2024,14132,
18,PLC TRADE BANNER,7531,Approved,14120,08-July-2024,,,,18,Conrad AUT,7820,Approved,09-July-2024,14140,
19,PLC TRADE BAUMER,7531,Approved,14120,08-July-2024,,,,19,Conrad CHE,7822,Approved,10-July-2024,14141,
20,PLC TRADE BECKHOFF,7531,Approved,14120,08-July-2024,,,,20,RayCanterParts,7825,Approved,11-July-2024,7936,
21,PLC TRADE DANFOSS,7531,Approved,14120,08-July-2024,,,,21,B2bStore,7835,-,11-July-2024,14233,
22,PLC TRADE IFM,7531,Approved,14120,08-July-2024,,,,22,Warehouse Kuhfuss Online,7832,Approved,11-July-2024,14234,
23,PLC TRADE KEYENCE,7531,Approved,14120,08-July-2024,,,,23,Stex,7830,Approved,11-July-2024,14235,
24,PLC TRADE MURR ELEKTRONIK,7531,Approved,14120,08-July-2024,,,,24,Conrad De,7793,-,12-July-2024,14188,
25,PLC TRADE OBO,7531,Approved,14120,08-July-2024,,,,25,Coburns,7861,Approved,12-July-2024,14229,
26,PLC TRADE OMRON,7531,Approved,14120,08-July-2024,,,,26, Precision Electric,7859,Approved,12-July-2024,14230,
27,PLC TRADE PEPPERLFUCHS,7531,Approved,14120,08-July-2024,,,,27,Warehouse Stationery,7971,Approved,17-July-2024,14346,
28,PLC TRADE PHOENIXCONTACT,7531,Approved,14120,08-July-2024,,,,28,Detail Zol,7967,Approved,17-July-2024,14278,
29,PLC TRADE Pilz,7531,Approved,14120,08-July-2024,,,,29,IPrice SGP,7970,Approved,17-July-2024,14322,
30,PLC TRADE SCHEIDER ELECTRIC,7531,Approved,14120,08-July-2024,,,,30,BigfaceNZL,7963,Approved,17-July-2024,14273,
31,PLC TRADE SICK,7531,Approved,14120,08-July-2024,,,,31,Aquilatech,7964,Approved,17-July-2024,14267,
32,PLC TRADE SIEMENS,7531,Approved,14120,08-July-2024,,,,32,AmdAutomation,8010,Approved,18-July-2024,14376,
33,PLC TRADE TURCK,7531,Approved,14120,08-July-2024,,,,33, FB Tronics,8011,Approved,18-July-2024,14377,
34,PLC TRADE WEIDMULLER,7531,Approved,14120,08-July-2024,,,,34,Hagenauer,8017,Approved,19-July-2024,14378,
35,PLC TRADE YASKAWA,7531,Approved,14120,08-July-2024,,,,35,BlumenBecker,8019,Approved,19-July-2024,14379,
36,tsme Breemes,7779,Approved,14185,10-July-2024,,,,36,Elektroprofi shop,8035,Approved,19-July-2024,14380,
37,Ish Hoffmann Industrieservice,7783,Approved,14179,10-July-2024,,,,37,Homag,8042,Approved,20-July-2024,14358,
38,Wechselrichter Online,7782,Approved,14178,10-July-2024,,,,38,CASE CH,8043,Approved,20-July-2024,14308,
39,Lieske Industry Electronics,7781,Approved,14180,10-July-2024,,,,39,Schmersal,8044,Approved,20-July-2024,14356,
40,Sp-Ecambios,7780,Approved,14187,10-July-2024,,,,40,Notebook Battery,8048,Approved,21-July-2024,14335,
41,Ams Elektro,7788,Approved,14177,10-July-2024,,,,41,NHPNZ,8049,-,21-July-2024,14333,
42,Italia Cuscinetti,7787,Approved,14190,10-July-2024,,,,42,MediaForm NZ Page,8050,Approved,21-July-2024,14331,
43,Maag Technic,7804,Approved,14198,10-July-2024,,,,43,FruugoNZL,8055,Approved,21-July-2024,14315,
44,Onergys,7802,Approved,14203,10-July-2024,,,,44,Fruugo PHL,8056,Approved,21-July-2024,14316,
45,Buyfilteronline,7801,Approved,14201,10-July-2024,,,,45,Dove NZL,8057,Approved,21-July-2024,14310,
46,ErsatzteilService,7800,Approved,14200,10-July-2024,,,,46,Hongtai Part,8071,Approved,22-July-2024,14330,
47,ElektroshopWagner,7799,Approved,14199,10-July-2024,,,,47,EBattery NZL,8072,Approved,22-July-2024,14311,
48,VOGEL DRUCKLUFT-TECHNIK,7784,Approved,14181,11-July-2024,,,,48,Lepus Tech,8093,Approved,23-July-2024,14328,
49,Mosel-Elektro,7819,Approved,14195,11-July-2024,,,,49,Lt-Litian,8094,Approved,23-July-2024,14329,
50,Automationdistribution,7821,Approved,14208,11-July-2024,,,,50,Mercateo CHE ,8119,Approved,24-July-2024,14263,
51,Modernequipmentparts,7824,Approved,14231,11-July-2024,,,,51,Voelkner,8121,Approved,24-July-2024,14301,
52,Misumi,7753,Approved,14072,11-July-2024,,,,52,Conrad,8123,Approved,24-July-2024,14264,
53,Parmley Graham,7796,Approved,14184,11-July-2024,,,,53,Conrad AT,8125,,25-July-2024,14265,
54,Younits,7847,Approved,14226,12-July-2024,,,,54,EBAY AUS,8151,Approved,25-July-2024,14277,
55,Koerschulte + Werkverein,7843,Approved,14236,12-July-2024,,,,55,EBAY DEU,8153,Approved,25-July-2024,14139,
56,Elesa + Ganter AUT),7845,Approved,14238,12-July-2024,,,,56,EBAY CAN,8171,Approved,26-July-2024,14143,
57,GMG Automation DEU,7848,Approved,14237,12-July-2024,,,,57,Schaeffler,8172,Approved,26-July-2024,14348,
58,14170-Broken_Tractor,7877,Approved,14170,12-July-2024,,,,58,Sintronics,8174,Approved,27-July-2024,14352,
59,ZiperOne,7953,Approved,14288,17-July-2024,,,,59,ZapchastiLviv,8173,Approved,27-July-2024,13218,
60,Le Site de la Piece,7944,Approved,14286,17-July-2024,,,,60,Voltimum,8175,Approved,27-July-2024,14354,
61,Fixpart BEL,7889,Approved,14247,17-July-2024,,,,61,Kokoris,8177,Approved,27-July-2024,14285,
62,Adapters NZL,7878,Approved,14261,17-July-2024,,,,62,GlobalTrade,8178,Approved,27-July-2024,14357,
63,Replacedirect NLD,7927,Approved,14248,17-July-2024,,,,63,LaptopBatteryMYS,8183,Approved,28-July-2024,14324,
64,SpareParts PRT,7957,Approved,14289,17-July-2024,,,,64,Voltking,8184,Approved,28-July-2024,14183,
65,Mijn Onderdelenhuis,7958,Approved,14282,17-July-2024,,,,65,Page Supply House,8185,Approved,28-July-2024,14420,
66,Zip-Portal,7940,Approved,14294,17-July-2024,,,,66,Walmart,8186,Approved,28-July-2024,14430,
67,Anzor,7876,Approved,14262,17-July-2024,,,,67, Alibaba CHN,8187,Approved,28-July-2024,14298,
68,GYS,7907,-,14221,17-July-2024,,,,68,Keilriemen24,8202,-,29-July-2024,14435,
69,Asianic,7919,-,14270,17-July-2024,,,,69,Eichler Service,8197,-,29-July-2024,14385,
70,Massinger Ulm,7969,Approved,14280,17-July-2024,,,,70,ConCar,8196,-,29-July-2024,14382,
71,Werkzeugwelt24,7985,Approved,14353,18-July-2024,,,,71,TXO,8210,-,30-July-2024,14211,
72,HGM Liftparts,7984,Approved,14307,18-July-2024,,,,72,DSG Supply,8209,-,30-July-2024,14218,
73,Elektroshop Wagner,7981,Approved,14360,18-July-2024,,,,73,Siemens Pro,8230,-,30-July-2024,14217,
74,KahmannEllerbrock,7980,Approved,14361,18-July-2024,,,,,,,,,,
75,Kugellager Shop Duesseldorf,7979,Approved,14367,18-July-2024,,,,,,,,,,
76,Meier,7978,Approved,14366,18-July-2024,,,,,,,,,,
77,Faber Industrietechnik24,7987,Approved,14350,18-July-2024,,,,,,,,,,
78,BuyAfterMarketParts,7986,Approved,14305,18-July-2024,,,,,,,,,,
79,Brander Landtechnik ,7994,Approved,14351,18-July-2024,,,,,,,,,,
80,hardy-schmitz,7993,Approved,14349,18-July-2024,,,,,,,,,,
81,Hydro-funk,7999,Approved,14388,18-July-2024,,,,,,,,,,
82,IPT Drives & Controls GmbH,8000,Approved,14386,18-July-2024,,,,,,,,,,
83,Modern Group,8005,Approved,14391,19-July-2024,,,,,,,,,,
84,Gciron New equipment,8004,Approved,14392,19-July-2024,,,,,,,,,,
85,S1 Parts Center,8001,Approved,14393,19-July-2024,,,,,,,,,,
86,JC Tech-Electronics,8016,Approved,14369,19-July-2024,,,,,,,,,,
87,Intelectra Shop,8013,Approved,14300,19-July-2024,,,,,,,,,,
88,ksk components,8012,Approved,14384,19-July-2024,,,,,,,,,,
89,Handwerker und Industrie Werkzeuge,8024,Approved,14390,19-July-2024,,,,,,,,,,
90,Lienkämper,8033,Approved,14381,20-July-2024,,,,,,,,,,
91,KAISER Nachfolger Montagetechnik,8031,Approved,14387,20-July-2024,,,,,,,,,,
92,Batterybuy,8030,Approved,14271,20-July-2024,,,,,,,,,,
93,Si.Serv GmbH,8036,Approved,14374,20-July-2024,,,,,,,,,,
94,krones,8041,Approved,14372,20-July-2024,,,,,,,,,,
95,allied controls,7883,Approved,14225,20-July-2024,,,,,,,,,,
96,Blässinger,8045,Approved,14370,21-July-2024,,,,,,,,,,
97,PTL Computers,8051,Approved,14342,21-July-2024,,,,,,,,,,
98,Polartech,8052,Approved,14340,21-July-2024,,,,,,,,,,
99,Elektro4000,7910,Approved,14266,21-July-2024,,,,,,,,,,
100,ImportTehSnab,7915,Approved,14216,21-July-2024,,,,,,,,,,
101,(Industrial Tools CAN),7911,Approved,14256,21-July-2024,,,,,,,,,,
102,leuze,8054,Approved,14370,21-July-2024,,,,,,,,,,
103,Technischer Handel Straub,7977,Approved,14365,22-July-2024,,,,,,,,,,
104,Traydon-Spareparts,7974,Approved,14326,22-July-2024,,,,,,,,,,
105,maschinenhandel,8053,Approved,14375,22-July-2024,,,,,,,,,,
106,eBay USA,7856,Approved,14138,22-July-2024,,,,,,,,,,
107,Amikon PLC,7892,Approved,14214,22-July-2024,,,,,,,,,,
108,Famaga AZE,7894,Approved,14215,22-July-2024,,,,,,,,,,
109,Knust,7827,Approved,14192,22-July-2024,,,,,,,,,,
110,staion one,7893,Approved,14257,23-July-2024,,,,,,,,,,
111,NBR,8062,Approved,14368,23-July-2024,,,,,,,,,,
112,Uni Elektro,8077,Approved,14401,23-July-2024,,,,,,,,,,
113,Preview NLZ,8076,Approved,14341,23-July-2024,,,,,,,,,,
114,Laptop Service Ind,8103,Approved,14326,24-July-2024,,,,,,,,,,
115,Industry-Pilot,8069,Approved,14406,24-July-2024,,,,,,,,,,
116,KSK Components,8070,-,14405,24-July-2024,,,,,,,,,,
117,ZW24,8090,-,14383,24-July-2024,,,,,,,,,,
118,Just Laptops,8089,Approved,14323,24-July-2024,,,,,,,,,,
119,Osiander,8088,Approved,14407,24-July-2024,,,,,,,,,,
120,Benad24,8086,Approved,14244,24-July-2024,,,,,,,,,,
121,123Kugellager AUT),8111,Approved,14416,25-July-2024,,,,,,,,,,
122,Ptac Solutions US,8110,Approved,14417,25-July-2024,,,,,,,,,,
123,Kaffee-Optimal,8108,-,14295,25-July-2024,,,,,,,,,,
124,KMG Industry,8116,Approved,14411,25-July-2024,,,,,,,,,,
125,Wie Tec,8114,-,14412,25-July-2024,,,,,,,,,,
126,NorthStock,8109,-,14418,25-July-2024,,,,,,,,,,
127, Laptop Battery SGP,8146,Approved,14325,25-July-2024,,,,,,,,,,
128,Blackhawk Supply,8143,Approved,14429,26-July-2024,,,,,,,,,,
129,Furnace Part Source,8142,Approved,14431,26-July-2024,,,,,,,,,,
130,Patriot Supply,8141,Approved,14432,26-July-2024,,,,,,,,,,
131,SparePartsNow,8140,Approved,14408,26-July-2024,,,,,,,,,,
132,Home Essentials Direct,8158,Approved,14427,26-July-2024,,,,,,,,,,
133,Ima-Tech,8118,-,14410,26-July-2024,,,,,,,,,,
134,KC-CO,8073,Approved,14403,26-July-2024,,,,,,,,,,
135,Grainger,8165,Approved,14423,26-July-2024,,,,,,,,,,
136,PartsHNC,8167,Approved,14426,26-July-2024,,,,,,,,,,
137,TallerTronic,7891,Approved,14213,26-July-2024,,,,,,,,,,
138,Groupe-Dragon FRA,7888,Approved,14249,26-July-2024,,,,,,,,,,
139,Parts Centre GBR,7887,Approved,14250,26-July-2024,,,,,,,,,,
140,Railauction.plus,7882,Approved,14259,26-July-2024,,,,,,,,,,
141,Messicks,7875,Approved,14224,26-July-2024,,,,,,,,,,
142, NZ Battery,8120,Approved,14336,26-July-2024,,,,,,,,,,
143,HP Laptop Battery NZL,8179,Approved,14318,27-July-2024,,,,,,,,,,
144,Batterybuy PHL,8176,Approved,14272,27-July-2024,,,,,,,,,,
145,HP Laptop Battery SGP,8149,Approved,14319,27-July-2024,,,,,,,,,,
146,noel leeming,8132,Approved,14334,27-July-2024,,,,,,,,,,
147,HP Sotre CHN,8136,Approved,14320,27-July-2024,,,,,,,,,,
148,Unitec,8170,Approved,14206,28-July-2024,,,,,,,,,,
149,Info System Services IND,8127,Approved,14321,28-July-2024,,,,,,,,,,
150,CENZ,8180,Approved,14276,28-July-2024,,,,,,,,,,
151,Conrad BEL,7870,Approved,14189,28-July-2024,,,,,,,,,,
152,Distrelec DEU,7922,Approved,14243,28-July-2024,,,,,,,,,,
153,Jacob (BUGFIX),8204,-,14434,29-July-2024,,,,,,,,,,
154,Loechecl Industriebedarf (BUGFIX),8203,-,14438,29-July-2024,,,,,,,,,,
155,Persicaner (BUGFIX),8200,-,14437,29-July-2024,,,,,,,,,,
156, eBay PHL,8188,-,14313,30-July-2024,,,,,,,,,,
157,Traydon-Spareparts,8224,Approved,14439,30-July-2024,,,,,,,,,,
158,HugTechnik (Bugfix),8229,-,14450,30-July-2024,,,,,,,,,,
159,Galco,8222,-,14428,31-July-2024,,,,,,,,,,
160,Bida Industry,8223,Approved,14436,31-July-2024,,,,,,,,,,
161,Sanitaerprofi,8234,-,14441,31-July-2024,,,,,,,,,,`;

const aug24 = `c,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,55,Є845.5,17,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,Cncbote,8432,Approved,14528,12-August-2024,,,,1,Belimo,8437,Approved,12-August-2024,14474,
2,Titan Machinery,8412,Approved,14484,12-August-2024,,,,2,Proshop AUT,8515,Approved,15-August-2024,14562,
3,kessler_electronic,8426,-,14465,12-August-2024,,,,3,CappUSA,8530,Approved,17-August-2024,From Sheets,
4,Heizun 24 Shop,8253,Approved,14456,13-August-2024,,,,4,PumpProducts,8530,Approved,17-August-2024,From Sheets,
5,Requtec,8386,-,14413,13-August-2024,,,,5,OntimeMall,8530,Approved,18-August-2024,From Sheets,
6,Aftermarket Express (Bugfix),8450,-,14491,13-August-2024,,,,6,EbirdsAll,8530,Approved,18-August-2024,From Sheets,
7,loechel Industriebedarf (bugfix),8449,-,14534,13-August-2024,,,,7,FurnacePartSource,8530,Approved,18-August-2024,From Sheets,
8,JIT Truck Parts ,8480,Approved,14579,13-August-2024,,,,8,URI,8544,Approved,19-August-2024,Requested By Amin,
9,Wie Tec,8484,Approved,14558,15-August-2024,,,,9,New Egg USA,8603,Approved,26-August-2024,From Sheets,
10,Distrelec DEU,8491,Approved,14563,15-August-2024,,,,10,Electric Motor Warehouse,8603,Approved,26-August-2024,From Sheets,
11,Etoh24,8512,-,14511,15-August-2024,,,,11,CE Motors,8603,Approved,29-August-2024,From Sheets,
12,Electric Automation Network DEU,8511,-,14509,15-August-2024,,,,12,IronWing Sales,8603,Approved,29-August-2024,From Sheets,
13,Arkov,8498,Approved,14587,15-August-2024,,,,13,Pratiker,8674,-,01-September-2024,908,
14,Ebay US,8517,Approved,14591,15-August-2024,,,,14,FleetPride,8676,-,01-September-2024,33,
15,Loechel Industriebedarf,8526,Approved,14592,15-August-2024,,,,15,RSdelivers ZAF,8677,-,01-September-2024,418,
16,StatesSupply (Bugfix),8530,Approved,From Sheets,17-August-2024,,,,16,BRW,8680,-,01-September-2024,246,
17,HVAC Discounters (Bugfix),8530,Approved,From Sheets,17-August-2024,,,,17,RSU,8681,-,01-September-2024,846,
18,Grainger (Bugix),8530,Approved,From Sheets,17-August-2024,,,,18,,,,,,
19,Controls Center (Bugfix),8530,Approved,From Sheets,18-August-2024,,,,19,,,,,,
20,Potter Pipe (Bugfix),8530,Approved,From Sheets,18-August-2024,,,,20,,,,,,
21,Home Essentials (Bugfix),8530,Approved,From Sheets,18-August-2024,,,,21,,,,,,
22,Apex Controls (Bugfix),8530,Approved,From Sheets,18-August-2024,,,,22,,,,,,
23,SPS Industrial (Bugfix),8530,Approved,From Sheets,18-August-2024,,,,23,,,,,,
24,General Supplies (bugfix),8530,Approved,From Sheets,18-August-2024,,,,24,,,,,,
25,Amazon CAN (Bugfix),8573,Approved,840,20-August-2024,,,,25,,,,,,
26,Amazon USA (Bugfix),8588,Approved,106,23-August-2024,,,,26,,,,,,
27,Partspring,8597,Approved,857,25-August-2024,,,,27,,,,,,
28,Intermountain New Holland,8600,Approved,858,25-August-2024,,,,28,,,,,,
29,Autoteile Preiswert,8601,Approved,845,25-August-2024,,,,29,,,,,,
30,Amaze Supply (Bugfix),8603,Approved,From Sheets,26-August-2024,,,,30,,,,,,
31,Parts Town Can (Bugfix),8603,Approved,From Sheets,26-August-2024,,,,31,,,,,,
32,Springer Parts (Bugfix),8603,Approved,From Sheets,26-August-2024,,,,32,,,,,,
33,Festo (Bugfix),8615,Approved,Request by Johannes,27-August-2024,,,,33,,,,,,
34,All World Machinery (Bugfix),8603,Approved,From Sheets,27-August-2024,,,,34,,,,,,
35,SB Industrial Supply (Bugfix),8603,Approved,From Sheets,27-August-2024,,,,35,,,,,,
36,eBay USA,8606,Approved,841,29-August-2024,,,,36,,,,,,
37,ubuy_id,8630,Approved,352,29-August-2024,,,,37,,,,,,
38,ubuy_za,8638,Approved,219,29-August-2024,,,,38,,,,,,
39,Grainger CAN (Bugfix),8603,Approved,From Sheets,29-August-2024,,,,39,,,,,,
40,Ferguson (Bugfix),8603,Approved,From Sheets,29-August-2024,,,,40,,,,,,
41,PentoolCo (bugfix),8603,Approved,From Sheets,29-August-2024,,,,41,,,,,,
42,Reliable Parts (Bugfix),8603,Approved,From Sheets,29-August-2024,,,,42,,,,,,
43,Parts HVAC (Bugfix),8603,Approved,From Sheets,29-August-2024,,,,43,,,,,,
44,UCUZKONFOR,8662,Approved,834,31-August-2024,,,,44,,,,,,
45,Mercado Libre MEX,8661,-,165,31-August-2024,,,,45,,,,,,
46,Tired Iron Tractor Parts,8654,-,788,31-August-2024,,,,46,,,,,,
47,Mabeo Direct,8653,Approved,568,31-August-2024,,,,47,,,,,,
48,e-ceryan,8672,-,17,31-August-2024,,,,48,,,,,,
49,Allmaq,8665,-,14601,31-August-2024,,,,49,,,,,,
50,Ubuy BR,8655,-,144,31-August-2024,,,,50,,,,,,
51,Farnell ISR (Bugfix),8675,-,65,01-September-2024,,,,51,,,,,,
52,CHINA MAKEPOLO (Bugfix),8678,-,389,01-September-2024,,,,52,,,,,,
53,Imall (Bugfix),8679,-,210,01-September-2024,,,,53,,,,,,
54,RS Online (Bugfix),8682,-,978,01-September-2024,,,,54,,,,,,
55,New Holland Rochester,8683,-,856,01-September-2024,,,,55,,,,,,
56,,,,,,,,,56,,,,,,
57,,,,,,,,,57,,,,,,
58,,,,,,,,,58,,,,,,
59,,,,,,,,,59,,,,,,
60,,,,,,,,,60,,,,,,
61,,,,,,,,,61,,,,,,
62,,,,,,,,,62,,,,,,
63,,,,,,,,,63,,,,,,
64,,,,,,,,,64,,,,,,
65,,,,,,,,,65,,,,,,
66,,,,,,,,,66,,,,,,
67,,,,,,,,,67,,,,,,
68,,,,,,,,,68,,,,,,
69,,,,,,,,,69,,,,,,
70,,,,,,,,,70,,,,,,
71,,,,,,,,,71,,,,,,
72,,,,,,,,,72,,,,,,
73,,,,,,,,,73,,,,,,
74,,,,,,,,,,,,,,,
75,,,,,,,,,,,,,,,
76,,,,,,,,,,,,,,,
77,,,,,,,,,,,,,,,
78,,,,,,,,,,,,,,,
79,,,,,,,,,,,,,,,
80,,,,,,,,,,,,,,,
81,,,,,,,,,,,,,,,
82,,,,,,,,,,,,,,,
83,,,,,,,,,,,,,,,
84,,,,,,,,,,,,,,,
85,,,,,,,,,,,,,,,
86,,,,,,,,,,,,,,,
87,,,,,,,,,,,,,,,
88,,,,,,,,,,,,,,,
89,,,,,,,,,,,,,,,
90,,,,,,,,,,,,,,,
91,,,,,,,,,,,,,,,
92,,,,,,,,,,,,,,,
93,,,,,,,,,,,,,,,
94,,,,,,,,,,,,,,,
95,,,,,,,,,,,,,,,
96,,,,,,,,,,,,,,,
97,,,,,,,,,,,,,,,
98,,,,,,,,,,,,,,,
99,,,,,,,,,,,,,,,
100,,,,,,,,,,,,,,,
101,,,,,,,,,,,,,,,
102,,,,,,,,,,,,,,,
103,,,,,,,,,,,,,,,
104,,,,,,,,,,,,,,,
105,,,,,,,,,,,,,,,
106,,,,,,,,,,,,,,,
107,,,,,,,,,,,,,,,
108,,,,,,,,,,,,,,,
109,,,,,,,,,,,,,,,
110,,,,,,,,,,,,,,,
111,,,,,,,,,,,,,,,
112,,,,,,,,,,,,,,,
113,,,,,,,,,,,,,,,
114,,,,,,,,,,,,,,,
115,,,,,,,,,,,,,,,
116,,,,,,,,,,,,,,,
117,,,,,,,,,,,,,,,
118,,,,,,,,,,,,,,,
119,,,,,,,,,,,,,,,
120,,,,,,,,,,,,,,,
121,,,,,,,,,,,,,,,
122,,,,,,,,,,,,,,,
123,,,,,,,,,,,,,,,
124,,,,,,,,,,,,,,,
125,,,,,,,,,,,,,,,
126,,,,,,,,,,,,,,,
127,,,,,,,,,,,,,,,
128,,,,,,,,,,,,,,,
129,,,,,,,,,,,,,,,
130,,,,,,,,,,,,,,,
131,,,,,,,,,,,,,,,
132,,,,,,,,,,,,,,,
133,,,,,,,,,,,,,,,
134,,,,,,,,,,,,,,,
135,,,,,,,,,,,,,,,
136,,,,,,,,,,,,,,,
137,,,,,,,,,,,,,,,
138,,,,,,,,,,,,,,,
139,,,,,,,,,,,,,,,
140,,,,,,,,,,,,,,,
141,,,,,,,,,,,,,,,
142,,,,,,,,,,,,,,,
143,,,,,,,,,,,,,,,
144,,,,,,,,,,,,,,,
145,,,,,,,,,,,,,,,
146,,,,,,,,,,,,,,,
147,,,,,,,,,,,,,,,
148,,,,,,,,,,,,,,,
149,,,,,,,,,,,,,,,
150,,,,,,,,,,,,,,,
151,,,,,,,,,,,,,,,
152,,,,,,,,,,,,,,,
153,,,,,,,,,,,,,,,
154,,,,,,,,,,,,,,,
155,,,,,,,,,,,,,,,
156,,,,,,,,,,,,,,,
157,,,,,,,,,,,,,,,
158,,,,,,,,,,,,,,,
159,,,,,,,,,,,,,,,
160,,,,,,,,,,,,,,,
161,,,,,,,,,,,,,,,`;

const advices = `Don't expect, you can only anticipate. Much will go wrong before everything goes right; Keep thriving. Nothing beyond Parents, they are everything. Never ever give up on your self; most importantly on your intuition. Past 27, look for settlement but not adjustments. Not everyone around is your friend, and a friend in need maynot be a friend in deed. Having heartbroken is okay, but Never let it break. Most importantly and maybe last one: it's not easy to be strong hearted, but at the least try to stay strong and stand by your own self. ❤️
--++--
Don’t underestimate the power of working a 9 to 5 Job.
--++--
emotional intelligence matters
--++--
Love and take care of your parents.. they are slowly getting old.❤️
--++--
In early twenties don’t think more about salary learn skill and become master of that skill then automatically money will follow you and at the same time have fun in a good way (socially acceptable) because once you pass your twenties you never get those golden era in your life time.
--++--
Take care of ur health.. don't take it for granted.. travel a lot.
--++--
Work hard stay focus and trust the process. Work as hard that u feel sorry for yourself and cry sometimes. Your time will come even if u are in slums u will be millionaire
--++--
1. Learn to live (and not just survive) by yourself because there are going to be days of perfect loneliness. 2. Spend time with your parents and be patient with them; the social media world and age of trends and coolness is actually new to them.
--++--
Government job is a trap..learn some good skills and keep learning..Choose a wise girl
--++--
Stay away from Options Trading this looks much easier in the beginning but by the time you realise, you will end up in TRAP which is going to cost you more than you imagined.
--++--
Be loyal to yourself ❤️ this is what matters
--++--
Be real and humble to others and yourself first.👍🏻
--++--
Dnt drink old monk with coke, have it with only water .
--++--
Pls like my comment so that I can come back.
--++--
1. Don't West your time for government jobs for more then 3 years.  2. For corporate sector learn something skills based 3. Listen to your parents they might be wrong about few things but in the end they just want to see you succesful.
--++--
The age of 19-25 isn't easy. You lose friends, you make mistakes, you fall, you fail, you realise things, you hit reality, you lose yourself but in the end you find yourself and you become stronger.♥️
--++--
Nearing 30’s and I learnt

1. Be kind to everyone and know your boundaries.
2. Spend time with parents & dearest ones before it is too late.
3. Anger is a reflection of your laziness.
4. Greatest wealth : Healthy Mind, body & Soul.
5. Don’t run behind love, money and fame try your best if it stays it is yours or it’s not meant to be. 

Love you all and wish you all the with lots of love, happiness, good health and wealth. ✨
--++--
Marry a simple village girl who will appriciate ur success and be a part of it.......spend time with dada dadi nananani and parents ...time chala jata hai
--++--
Don't forget Goal for a little hole!!
--++--
Jo tainu ajj lagda dost sab kuch ne, pr asal vich zindagi ik solo journey hai. Jini jaldi eh gal samajh launge, ohna hi zindagi sokhi lang ju nhi ta war war disappoint hovoge
--++--
Life truly begins after 27 when you have money! Make money, travel, take your parents for shopping and dinner. And yes, she's gonna leave. Don't waste your time
--++--
Slow down God has better plans for you..!
--++--
Invest in yourself — whether it’s your health, skills, or mindset. Your 20s are about building the foundation for the life you want, so take time to learn, grow, and create habits that will pay off later. Take care of your parents, they won’t always be around. Stop chasing girls and focus on your goals — trust me, consistency beats intensity any day!
--++--
Everyone in comments 🙌❤️
--++--
Take care of your finances ... Save little every day, you don't know how it will help you in the long run. Love ?? It will find you.. I promise. Keep hustling
--++--
1. Take Risk Either You Learn or successful.  2. Your Bestfriend Will Betray you Don't trust anyone. 3. TAKE Care of your Parents Health . 4 Never Disrepect Your sisters they are real caretakers.
--++--
If the girls didn't choose you when you were poor.... don't marry old girls when you are rich
--++--
Respect your parents 🙌. Start saving early , health is priority
--++--
Don't expect, you can only anticipate. Much will go wrong before everything goes right; Keep thriving. Nothing beyond Parents, they are everything. Never ever give up on your self; most importantly on your intuition. Past 27, look for settlement but not adjustments. Not everyone around is your friend, and a friend in need maynot be a friend in deed. Having heartbroken is okay, but Never let it break. Most importantly and maybe last one: it's not easy to be strong hearted, but at the least try to stay strong and stand by your own self. ❤️
--++--
Don’t underestimate the power of working a 9 to 5 Job.
--++--
emotional intelligence matters
--++--
Love and take care of your parents.. they are slowly getting old.❤️
--++--
In early twenties don’t think more about salary learn skill and become master of that skill then automatically money will follow you and at the same time have fun in a good way (socially acceptable) because once you pass your twenties you never get those golden era in your life time.
--++--
Take care of ur health.. don't take it for granted.. travel a lot.
--++--
Work hard stay focus and trust the process. Work as hard that u feel sorry for yourself and cry sometimes. Your time will come even if u are in slums u will be millionaire
--++--
1. Learn to live (and not just survive) by yourself because there are going to be days of perfect loneliness. 2. Spend time with your parents and be patient with them; the social media world and age of trends and coolness is actually new to them.
--++--
Government job is a trap..learn some good skills and keep learning..Choose a wise girl
--++--
Stay away from Options Trading this looks much easier in the beginning but by the time you realise, you will end up in TRAP which is going to cost you more than you imagined.
--++--
Be loyal to yourself ❤️ this is what matters
--++--
Be real and humble to others and yourself first.👍🏻
--++--
Dnt drink old monk with coke, have it with only water .
--++--
Pls like my comment so that I can come back.
--++--
1. Don't West your time for government jobs for more then 3 years.  2. For corporate sector learn something skills based 3. Listen to your parents they might be wrong about few things but in the end they just want to see you succesful.
--++--
if u starts smilin when u receive a text from a particular one “delete that num”
--++--
Never touch that first cigerette , never ❌
--++--
Bhai pehle to
1. Jaisa chal rha waisa chalne do, be consistent!
2. Jis chiz me interest hai wo kaam karo, seekho, Be the best in what you do!
3. Paisa Important hai, toh savings, Investments, insurance, money management karna Banta hai! be money cautious!
4. Jo bhi job kar rhe ho, Jo bhi company ho, jyada se jyada usme tike rho, experience is important!
5. Ek acchi ladki se dosti karo, relationship ho rha hai to hone do, emotional angle se tabtak mat socho jabtak tum dono ko lagta nhi ke tum ek dusre ko pura samajh lete ho, accept kar lete ho. Ladki patane ka yahi time hai, pata ke rakho, baad me shadi ke liye arrange marriage ke time milti nhi hai!
6. Unplanned trips, ghumne ke liye, Paisa side me nikal ke rkho, uska corpus alag rakho.
7. Apne profession ke alava, agar kuch aur chize karni acchi lagti hai to uske liye Paisa nikal ke rakho.
8. Last, Keep a fail safe emergency fund, emergency place to live, emergency contact.
--++--
Once you will lose emotional connection with someone 
You will feel how ordinary they are
--++--
Your mom deserves it more.
--++--
Goated comments section🔥🙌
--++--
@ajeet_singh_mahar
--++--
1. Speak less! The more you say, the more you become bound by your words. But when you hold back, you remain in control, master of your silence.

2. Your youth is a priceless gift, filled with strength, resilience, and the power to turn your dreams into reality.

3. Stress can weigh you down, but it’s also a sign of your strength and resilience. Embrace it, channel it, and use it as fuel to overcome challenges and achieve your goals.

4. It’s wise to seek advice from elders & parents they’ve walked the path you’re on now and can guide you to avoid the mistakes they once made. Their experience can be a valuable tool in your journey.

5. Value your time, for it is the one resource you can never get back. Manage it wisely, and it will lead you to success.

6. Small, consistent investments may seem modest, but over time, they build a solid foundation of wealth. Start early, be patient, and let your money grow steadily.

7. Caring for your parents’ and grandparents’ health is one of the greatest responsibilities. Stay attentive, encourage regular check-ups, and support their well-being with love, patience, and understanding. Spend quality time with them, and have heartfelt conversations; your presence and attention mean more than you know.

8. Don’t rush into relationships; take your time to truly understand and connect. Building a strong, meaningful bond requires patience, trust, and genuine effort.

9. Balance is key in your career; work hard, but don’t forget to take time off. Rest and recharge are essential for long-term success and well-being.

10. Managing both mental and physical health is essential for a balanced life. Make time for exercise, eat well, and rest, but also prioritize your mental well-being by staying connected, practicing mindfulness, and seeking help when needed. A healthy mind and body go hand in hand.
--++--
Don't smoke
--++--
Don't marry... Live a simple single life 👍
--++--
Not 30 but itna smjh gaya hu ki jo cheez khatarnak dikhti hai wo khatarnak hi hoti hai..so stay away
--++--
sirf paise kama bhai sirf vahi kaam aayange or kuch bhi nahi paise honge to fav person bhi tere sath hoga otherwise wo bhi door ho jayega to bs paiso pr focus kro bs paiso pr😇
--++--
Bhai jo gadi leni hai kamai karle fir kharidna , Maa baap ko mat kharid ke maang , filhal moped pe sharam aaye to bhi chala le .. ek din teri bhi wo bike hogi jo tu chahta hai.. bas apne dam pe karna … aur haan maa baap dushman lagne lage to samzh jana yaha se sudharna padega galat direction pakad liya hai .. best luck and max love
--++--
Choot ki jagha career per focus karo..
--++--
Family First, Health Must. Make sure you have ample wealth before you take decision to marry someone !!
--++--
Earn as much as possible!!🔥Yes Money Can't Buy Happiness, it buys Happiness,peace, love, even people for sure🙌
--++--
In your 20s you will not have a lot money but what you will have is time and freedom, don't waste it, try to make the most out of it.
--++--
Stay focused on your goals, avoiding distractions from relationships and staying away from relatives. Be gentle with yourself, but don’t hesitate to take risks as you figure out the best path forward.
--++--
If you are lower middle class boy like me then in our home , buy all good materialistic things that your parents not experienced what ever they wanted to eat just give them because all efforts are for our stomach  if you are not able to travel with them because of money issue that's fine but as I said this things you should do first 🙏
--++--
Jawani wapas nahi ayegi. Family 1st. Ladki k piche kise marji asi tasi kra lo dhoka milega.  Jawani me utla sidha khaya 30 k baad band bajata hai. Tension lene ka nahi sab ho jayega.
--++--
Open a Roth IRA and invest it in a stock index fund; find a partner who has the capacity to make an independent living like you; don’t marry before turning 25; don’t have kids till you are 30; don’t get into addictions of any kind.
--++--
Don't share your happy stories. Learn to have good times with yourself. Enjoy everything. Get depressed and stand up as well. Take care of your parents even if they are rude to you or they haven't supported your passion. Always put up a little smile and last but not the least,  respect what you have❤️
--++--
Don't waste gems in clash of clans if you are a new player 🙏.
--++--
Sit with yourself, go through what you're feeling, don't switch or block your feelings. You're the hero who will save yourself !
--++--
Never compare yourself with anyone everyone is going according there time period जब तुम्हारा समय होगा तब सब अपने आप हो जाएगा तुम कितना भी दुःखी हो लो 18-20 की उम्र में कोई लखपति या करोड़पति नहीं बन सका so don't stress to much enjoy your current moment
--++--
Zindagi mei tum sab kama Lena Paisa shoharat izzat naam kaam sab kuch but at the end yaad tumhein tumhara bachpan hi aayega or tum kahoge ki bc bachpan hi sahi tha yeh kaha tension wali zindagi hogayi
--++--
at the end you will be ALONE .so leave all the tension aside and enjoy your time alone.
--++--
Be materialistic enough so that you can enjoy the spiritual life in the later phase of your life ❤️
--++--
Ek bar dost ke sath business try jarur Karo.
--++--
Haar maan gye to haar jaoge. Invest in yourself and build strong habits, because from rock bottom you’ll reach the peak. Fikar not yaar, sab kuch hojayega theek—just keep pushing forward and only win 🏆!
--++--
Just focus on your carrier. Ladki aa hi jaegi. Agar iska chronology ulti hui toh, ladki toh jaegi hi, aur fur itna late ho jaega ki depression me marega.
--++--
Enjoy your life & save some money too
--++--
Marry a simple village girl 💓
--++--
Control your 🤬.... Don't switch company frequently
--++--
Start making friends with people in business
--++--
Start early as soon as possible don’t think that you will have plans for the future oh just 10k per month? I will not do this job I will be an influencer or you-tuber or i will start a business !! Get a job work on your dreams along with your job and most importantly save,invest wish I listened to my parents. earning at right age will shape your future. Now I do earn but it’s not sufficient as I am married. I sacrifice a lot now. Take care.
--++--
Whatever you are planning to do. Just Don't reveal until its done🙂
--++--
Bhai khud pe focus kar...dusro ko impress krne chod de...aur career pe dhyaan de jitna jaldi hoske settled hoja ...uske baad hi pyar mohabbat ye sb me prna warna nahin prna nhi toh zindgi jhand hojyegi. Financial freedom is sbse important.
--++--
Belive me Time Flies do what you want to do 🤗🤗🤗
--++--
There is nothing called smart work .... The only way to success happiness and peace is to work hard spend time with your family workout don't just people
--++--
Class 12th me kuch vi ni pda paper 3 mahine baad h 11th bhi bekar h 😢
--++--
Maa chudao bc !!
--++--
Dude the comments 🔥🙌❤️ Experience talks about it!
--++--
Marry as soon as possible,.... Don't listen and who say delay the marriage,.. especially children of the Deeni followers....
--++--
Follow your gut feelings
--++--
Don't smoke indiemint
--++--
Shaadi kabhi mt krna
--++--
Hanuman chalisa abhi se padho! Jitni aish hai abhi krlo. Baad mein aish vala scam hai!
--++--
Don't Go For Beauty Go for Understanding Person Nhi toh bhut Dikkat Hogi
--++--
Ey relation paniki raadhu nee deggara dabbu lekunte 😂 ninnu dekhni kuda dekharuu bhayya
--++--
1) Master any skill, necessary for survival 2) Avoid alcohol, smoking and sugar 3) Don't be available all the time and learn to say 'No:
--++--
I'm 16 and pls tell me how can I leave fap and corn addiction 😭
--++--
Jyada kyu soch raha uncle aunty aa jayanga jaldi latak jaaa 😢🙏
--++--
Be wise with money and dont take decisions in a hurry also family should be top priority
--++--
Moj lo bhaiiyo
--++--
Bcod barbad ho jao mujhe kya
--++--
Don't take advice just go with the flow
--++--
Don’t settle for less in life. Keep hustling ❤️
--++--
Drink beer save water
--++--
Respect women
--++--
Don't waste your time here... enhance your skill and make good money...and never ever trust blindly anyone in your life
--++--
Mazze karo padhai kam
--++--
First thing you aren't the main character in life but you are you an unique too be humble there will be lot of people who breaks trust so if u think trust isn't important then you are wrong you just trust yourself then yeah atleast you might find happiness
--++--
No matter what , don't  forget to breathe 😁
--++--
Friends are not life. Parents are 🙏
--++--
Don’t take that First puff🙏
--++--
chut ke pecha mat bago😹
--++--
Save kar leta hu parso tak padhunga ❤️
--++--
भाई मा बाप के साथ ज्यादा से ज्यादा समय बिताओ और  हमेशा मा बाप की कदर करो, हर सफलता माथा चुमेगी
--++--
😂😂😂
--++--
Spend time with grandparents or old age people. Work for the growth of your skills.
--++--
Assumption is the lowest form of communication!
--++--
Jitna jaldi ho ske utna jaldi bhakti me utrna seekh lo🙏
--++--
Gym study and prayers is essential to become successful 🙏
--++--
Believe and stay healthy. @harsh___pathak
--++--
Make your parents happy.
Choose ur partner wisely.
And save money.
And don’t hesitate to propose someone, don’t be late.
--++--
Invest mind in building skills🧑‍🎓, Invest money in building wealth🫅
--++--
Don't play the husband role in your 20's 👍
--++--
Time is the biggest asset you have
--++--
Respect your parents
--++--
Die
--++--
If u r 18....Study hard. Bhai zindagi baad mai bohot leti hain. Sahi waqt pe sahi insaan mil jaaega. Work life balance is God damn important. I am 35...with money and a body thats betraying me. I have not taken care of my own body and mental well being.
--++--
Measure twice, cut once.
--++--
Reserve DISTRUST as your primary response for everyone you meet.
--++--
Stay away from girls and loans
--++--
Don't fear. Go for things you want. Don't overthink.
--++--
Don't invest in women 🙏
--++--
SIP start karo 🙂
--++--
Don't waste time in government job, not more than 1 year 🙂
--++--
Is mass communication worth it?
--++--
Save money and don't stress.. everything will come to your hand someday... All the best 👍
--++--
Get fuck your time then you will realise your self
--++--
Never fall in love it's destroy you
--++--
Life is not a race, find your pace and go with it. Its you vs you. 👍
--++--
Enjoy your time with your family and loved ones. A day will come when you will give anything to have that but it won’t be possible.
--++--
Be wth your parents respect them...love them...❤️
--++--
World is fake... Don't expect a genuine stuff...
--++--
Take care of your parents in all aspects of your parents :)
--++--
Enjoy it while you can
--++--
Spend most of the time with your family.
--++--
Three days grace - never too late
--++--
Live every moment, let the time do the rest , respect every single person!!
--++--
Kam bolo, plans kisi se share mat karo... and passion follow karo bhai.... meko ghoomna tha.... socha tha ki job k baad independendent hoke ghoomunga... but kab saari responsibilities mere pe aa gayi pata hi nahi chala😢😢😢... so bhai...... man mat maarna kabhi ..... kuch aisa mat karna ki baad me regret ho....... all the best..... k
--++--
Squad squad krte rehte ho...35 ke baad koi nhi milega .. sb khatam
--++--
Next 5 years will create the greatest wealth gap known to the world. Work hard now so you can be on the other side
--++--
29 waale kya gaand maraye benchod?
--++--
Win in private
--++--
Enjoy college days and university days as much as you can ✌️
--++--
Life's lesson: 



1. One day everyone is going to die.



2. No one is your competition, here.



3. Avoid falling in delusional trap of being called Intelligent, Beautiful, Smart or any kind of humanly praises.
--++--
Work as much as you will never have Regret that some more Would have made your life ....
--++--
Bc do job initially until u earn for ur investments
--++--
Build something for your self, dont regeret later after your 30's, part of the life
--++--
Start that business you wanted to, the biggest regret is not trying, not failure.
--++--
Dont overthink.. just do what u r doing..
--++--
Patience is the key,  you will get there!
--++--
Don't invite girls who party too much and f around. Save money. Be humble. Respect ur mental peace. Don't over work
--++--
Dont buy anything on EMI
--++--
Learn and know about sthitaprajna and don't stop praying🙏 hare krishana 💖🦚
--++--
Take care of yourself 👍.
--++--
Stay disciplined, patient, and emotionally detached🔥
--++--
Nothing stays with you permanently 
Just live the moment
--++--
you comes first before anything...invest in you....love yourself...be yourself...rest follows
--++--
Study well and speak nice to your parents. Invest your money and don't buy luxury items for society
--++--
Work for Money and Meanwhile don't forget your Mental Health and Physical health, Keep your body active don't take it for granted. Your body is the only real estate you'll really invest and live👍
--++--
Start investment in mutual funds..
--++--
Insurance and mediclaim asap
--++--
Just hide ur pain and wear a smile.
--++--
Don’t ask for advice. Experience everything and life makes you humble.
--++--
Take care of Parents and build money making ways
--++--
Spend time with parents before its too late.
--++--
Respect your Parents, Do hardwork, Develop skills, Earn money and try to create a wealth instead of wasting it on stupid stuff for showoff..
--++--
Avoid Starbucks and put that money in SIP at 18. You will not regret it at 40.
--++--
Don't expect anything from anyone else besides your parents , they are the person who always stand with you, support you and never disrespect them.
--++--
like this comment, so i can come back everytime and get motivated 🫡
--++--
Not 30 but.. become spiritually fit physically fit and financially fit rest things will settle itself ✨️🤍
--++--
Be consistent 🙌
--++--
Nothing is permanent... Not happiness, not sadness ... Not success ... Not failure... So, live, enjoy, spend time with your family because that is what only matters ... !!!
--++--
Pariwar hi sab kuch hai ❤️
--++--
Don't change your career goals or  decisions for a girl🙏🏻
--++--
1. Learn to live (and not just survive) by yourself because there are going to be days of perfect loneliness. 2. Spend time with your parents and be patient with them; the social media world and age of trends and coolness is actually new to them.
--++--
Time does not heal anything, it just teaches one to live with pain.
--++--
Travel travel travel
--++--
Earn earn earn save money give ur best before 40 u have to be rich so u could give a luxurious life to your mom dad your children
--++--
Work work work dont look back concentrate on your career thats it jab tak jaib mein paisa hai duniya bolegi kaisa hai
--++--
I'm 21 years old now ,I'm  happy by just seeing this comment section where many of you talk about parents ❤️🙌huge respect for you guys 🤗
--++--
keep your mind peaceful, dont let anyone to fuck it off.
--++--
Just go with the flow, try to travel as much as possible. Focus on ur fitness and health. Don't reveal until it's done
--++--
Focus on career take care of mom &dad before they're gone. don't do stupid stuff think about your mom &dad before
--++--
I feel a sense of emptiness(currently my age is 24)... Kuch krne ka mn nii krta dost bnane ka mn nii krta pr koi achha dost chahiye...schha pyaar chahiye pr aajkl ke breakup tradition ko dekhke mn nii krta...koi dost nii real life me na koi kareebi...focus Krna chahta hoon sirf career pe bt always Aisa lgta jaise sbkuch khaali empty empty sa h and everything is meaningless...What should I do??
--++--
Dank dook, chigma, red pill Falana dhimkana londo se door rehna... listen to women of your house.👍
--++--
Dont listen to anyone give respect to everyone but do what makes you happy 😊 stop thinking about everyone you can please them even your parents siblings reltives friends partner anyone stop trying and start thinking about your self ❤️
--++--
I turned 23 recently i tried to get into job asap since I graduated last year but couldn't then I tried a course but it didn't work too I don't know what to do any advice is appreciated
--++--
Insta delete kar de
--++--
Take it easy, Dont be in a race! God's Able🙌
--++--
Whatever you do do it with full honesty and love your family specially Parents ❣️
--++--
Charas aur chut se dur raho
--++--
chase money, not girls
--++--
Be your parents' best friend ❣️
--++--
Gratitude, keep your head up, be grateful and work hard.
--++--
Don't judge people; everyone is fighting their own battle, and everyone has their own struggles. Life is too short; don't hold grudges against others, and don't be too hard on yourself.
Love your parents; they're experiencing old age for the first time, just as you're experiencing adulthood for the first time.
Be kind, be empathetic. Remember, everyone's story is unique, and everyone's struggles are real.
Don't judge, instead, understand. Let go of grudges, forgive easily. Be gentle with yourself, you're learning. Cherish your parents, they're precious. Practice kindness, empathy, and compassion.
Live life with love, humility, and gratitude.
--++--
Is bkl ki reel par report maaro
--++--
@shhiv91 aapki baat ho rhi hai advice do😌
--++--
Don't open up too much. Keep the final trick for lifetime
--++--
Stop asking people the savings they have, the car they own, the brand they wear or the job they do ! Don't judge. Let people be what they are doing with their life. Asking about things that money can buy only multiplies the materialism ideas to others. It's okay to live a life people don't understand.  Ask yourself the things you own that money can't buy. You can have a small house, a cat/dog with you, a passion that makes you happy. Passion doesn't always needs to earn you money, it needs to make you happy. Stop comparing. :)
--++--
There's no such thing called pure love in this generation except your parent's. You're only loved for what you provide,  everyone's only after your money, so work hard, earn money, then only society will give you respect and your uncle will give you his daughter
--++--
Take care of ur health
--++--
Don't go to college regulary that is West of time.
--++--
Always love your parents bcoz once they gone......nobody is yours in this life......mark my words guys......😢😢
--++--
Only one advice padh lo accha
--++--
Forever is a lie. 😇
--++--
Choose your friends wisely. You are gonna regret in future..
--++--
Become 30 quickly and give advice in this post.
--++--
Credit ki zindagi chod dena
--++--
Don't take your life too serious, enjoy the moments
--++--
Ipoindo  chekkestaru nidi 🙌
--++--
1) health should be top priority 2) Learn to manage time 3) if you commit to something, give 100% before you give up on it. 4) family always comes first. 5) love more and judge less. Do not cheat .  Remember, the decisions you take in you 19&20 shape your 30s.
--++--
Work in your limits, follow your passion, Be grounded and grateful to your parents. Life is unpredictable never ego your present good times.
--++--
spend money on your parents when you start earning, don't get a credit card, be friendly with everyone but trust no one. Family is the most important thing they are only one you will find standing with you when you are down.
--++--
Comment section 💪💪
--++--
never date someone who is having male/female best friend i repeat again never date someone who is having male/female best friend bye!!!!
--++--
Focus on your goal ...bina baat k jhagro mai mat uljho .... 🙌❤️ ya to maafi mang lo ya phir maaf kardo ❤️ make your life simple bina baat ki show off mat karo... Aur at last social media uninstall karo 😂
--++--
Bs bhai kuch bhi karke ek achi si job ya source of Income fix kardo, asa kiye toh sb tumhare control mein or nhi kiya toh tum sbke control mein 👍
--++--
Don't touch drugs in this crucial year of life if you want a successful life and if you do try it please do not make it your habit.
--++--
No one still knows what's going on in their lives.. don't stress too much ..
--++--
be focused on being Successful Person,  otherwise this world will not respect you.
--++--
Maa baap se burkar kohi nahi iss duniya mai.. 💓💓💓
--++--
Do whatever you want in life but make sure to spend some time with your parents. You can conquer the world but it wouldn’t make you happy if you don’t have your parents to celebrate it with
--++--
Keep ur mental above then ur emotions 🔥
--++--
Never fall in love until you are successful!! Never 🙏
--++--
No matter what you do... You will be in 30s and then in 40s.
--++--
There will be no one, to help rather than you and your parents so make yourself strong financially physically and mentally. Put your own happiness on the top priority and take responsibility of your parents. Find a way where you can manage your income with family and friends. Keep calm and compose in your mint always Everything gonna be alright very soon ❤️
--++--
Muscle grow sab rakho udri .chota he sahi business koi b open Karo ,wo paisa invest Karo 15saal baad indian market will grow ❤️
--++--
Apne chacha ki gnd fadd kr zameen lelena nyto ye bhn k loda dega ny.....fir uski gnd fadni padti h puri samaj k samne.....esliye savdhan rahe phle hi apni zameen lele
--++--
Marry a girl who respect you, love you.
Spend time with your parents. Take them on vacations, holiday. 
Work on your physique. 
Money opens lot of gates which you never thought even exists.
--++--
Yek bat yaad rakho parents ki age ho rahi he 😔
--++--
Parents , family is all that should matter to you most 🙂.
--++--
The world will say money is not everything, ignore them 

Money solves 95% of the problem so work hard and accumulate shit load of money.
--++--
Don't trust girls except you're sister. Believe in you're parents Spend as much time as much you can. Give Them happiness That they deserve.
--++--
Family first everything comes second🙏
--++--
LOVE YOUR WIFE OR SHE WILL LEAVE. SHE ISN'T YOUR PARENT THAT HAS TO PAMPER YOU.
--++--
spent more time with your parents, friends may come and go, but your parents are irreplaceable.
--++--
Be very very selective about your company
--++--
This comment section is so different from same post where women were asked to advice the younger girls most of them said DON'T GET MARRIED unless u earn something that's clear that how man have treated women n here most of them are focusing on parents not a single comment DON'T GET MARRIED instead marry simple village girl have been commented why because she can be easily exploited wow boys wow 👍😂😂
--++--
don't West time..steady aur Schell develop your self.. other wise very rigret after that.
--++--
1.Be kind 💯respect your parents😍 keep your family happy , improve your skills ,spend time with you  loved one ,Focus on goals ,Make the time Useful ,Don't search for love it will come to you at right time ,Save your money ,travel explore the world ,keep smiling 👍,Adopt a pet 👍relax don't rush anything in life ....
--++--
Don't do anything to meet someone else's expectations.
--++--
The one piece is real 🗣️🗣️
--++--
Maturity is when you realise parents are the most important part of your life 💞
--++--
Get a pre- nuptial done
--++--
Does CGPA really matter?
--++--
Bhai jo karna hai wo kar yeh mat soch ki aage kuch galat hua tho jab tak try nhi karega kuch nhi hoga
--++--
Galtiya maf kar do sab ki...😌
--++--
पैसा कमा... क्योंकि याद रखना लड़को के लिए "माल है तो मोहब्बत है"
--++--
Hey my young brothers. Please try to love for yourself.  Dont be rude to your parents
--++--
Never trust anyone blindly....enjoy every moment of your life... If possible save some money for future....spent time with your parents
--++--
Kisi pr trust mat krna bas mom dad hi hai apny is dunya air koye nae
--++--
Choose a right person in your early
--++--
Start investing as early as possible...
--++--
Save money for family expenses
--++--
Parents k sath time spent kare jyada se jyada...😢😢😢
--++--
Happy to see genuine advices from elders..thanks 👍🏻
--++--
The life which u have seen until now is not permanent for example the problem which may feel heavy for u might feel lite in the future due to lack of experience and maturity,this is the time most of the teenagers choose the option SUICIDE.So my advice is take time for all the things so automatically decisions will be wiser 🙌
--++--
1. Have a regular source of income, whether with a job. 2.keep doing side hustle by learning and using new skills which interests you. 3 You may be a good and kind soul, loving everybody, but with time it won't matter. If you cannot afford or support their needs. 4 Thus earning and having own money will give you  freedom and after that only you can provide others after whoch you will find that they love you a lot. 5  Try to help love support others but start with yourself. 6 Lastly if you are not dependent on anyone for money, than you are best, after all this is financial world. PS you may think I am talking a lot about having own money, it's just with experience and if you consider me wrong than you have time to grow up. 😂
--++--
Everything gets better with age.. except for the wounds to your heart and soul.. protect that at all cost.. don't invest time and effort into something that's going to hurt your heart 🙏
--++--
1. Take care of your family. 2. Unconditional love doesn't happen with your lover. Everyone has their vested interests. 3. Take risks for your career-growth. 4. You will have a limited friend circle or a friend. Everyone else is a part of crowd. 5. Take care of animals on the street(dogs,cows etc). They will never forget your gesture. Lastly, take care of their physical and mental health.
--++--
Guys a general question should we invest a crore on education??
--++--
Focus on building your foundation strong, read learn spend time with parents
You will get all the time to enjoy in life. These days won't come back
--++--
Family first priority
--++--
Enjoy ur mind, exercise your body, spread the love around and be grateful!
--++--
Gay mat bano bas
--++--
Don't try to fit yourself in someone else's definition of success.
--++--
Thayavu senji padinga da 🙏 before 26 try to choose a proper career and get settle down 🙏 focus only on that. Remaining lam thana varum👍
--++--
Start investing ............... on self.............. and stocks👍
--++--
Dont stress out too much on anything at the cost of your health.. Nothing is more important than your health
--++--
Not a 30 person, still in my 21, I would advice u few things:-
1) Always be kind no matter what’s the situation…
2) Parents are everything 
3) Never fall in one sided love , never how hard it is just move on!!!
4) Focus more on Real than Reel
5) Not everyone deserves to be ur frnd , some are just classmates, use the word frnd consciously ✌️
--++--
Your parents are and will always be your mos important assest. When you'll be 30+,may be your parents wont be that fit that you'll have the luxury of taking them out for anything.. Live with them today.. जी भर के
--++--
Discipline is key to immortality..❤️
--++--
Instead of impressing some one by taking care of them, take care of you self , spen money on your self , add value win some competition, and write notes at what age you wanna get settled and work hard for your goal, money is god in this world , these advice can spare you from regrating
--++--
Enjoy your life & save some money too
--++--
be patient things will get better soon
--++--
Leve your life with lots of love and happiness spending time with your family make 2 3 aur 5 not more than that and try this friendship stand till your last breath don't fall in love before 25 and fall in love with someone who is also fall in love with you and make sure at a age of 23 aur 24 your are earning atlist your own basis expense and most important love your mom and dad
--++--
What about 12 to 17🥲
--++--
Don't waste much time preparing for a govt job, starting early with less is better, choose a partner wisely, don't hesitate to do what you feel to do in the right way
--++--
Always your health and parents come first.
--++--
Spend money on yourself not on looks whatever you spend on yourself is going to be appreciated but your looks definitely going to be depreciate
--++--
Spend and invest money and time on parents. Before marriage transfer everything in name of parents and before marriage, tell the girl your worth is zero INR or $$. Don’t be fooled by emotions of new girl. Laws in India are biased against men. So be very careful. Only a good girl will marry you then.
--++--
1. Never start any business with your friends/relatives even if they are rich/talented 
2. Start earning as early as possible despite your passionate job. Think, sometimes your passion may not sufficient to make money.
3. Definitely,Money can buy happiness. So go out, break your comfort zone and start earning.
--++--
Meri advice yhi h bhai aise baklol post pe jada dhyan na deke pdhayi pe dhyan de lena or kch bn jana nhi to baad Lanka lg jayegi
--++--
Backpain due to excessive sitting is real. Learn Horse ride, do Ladakh bike ride and anything which needs healthy back while you have bulletproof back!
--++--
Start investing no matter how smol, and take care of yourself I mean teeth, skin and physically active
--++--
Dont marry
--++--
Take care of your parents ❤️
--++--
Don't smoke indiemint
--++--
Women love your money and success not You. Avoid the trap and stay happy.
--++--
Ma chuda
--++--
Beleive in yourself, may b you don't know what to do with your life or you're never going to know what to do with your life,
--++--
U are not leading life.... Life leading u
--++--
Work on growing your career, as if your life depends on it. There's nothing more fulfilling than having a good career!
--++--
START SIP & DON'T TAKE HOMELOAN
--++--
Be kind to everyone. Karma exists, good deeds come back.
--++--
@biju_pdl
--++--
Nullius En Verba. ♾️
--++--
Don't believe in anyone, except your parents
--++--
Don't forget to live life while you're struggling for success. And never prioritise anyone above you.
--++--
Joint hath me lekr bol raha hu nashe mat karna bhai 🙏
--++--
Don't take advices from relatives or friends. Make your own risks
--++--
Heartbreak is a blessing
--++--
Don't suffer your parents for your needs...!
--++--
1. START SAVING MONEY.
--++--
27 ki umar mein heart attack kyu ata hai?
--++--
Always love your parents. Don’t be rude to them. Be there with them always.
--++--
Whatever you are planning to do. Just Don't reveal until its done🙂
--++--
Never break someone's family 🙏 for one night happiness
--++--
thanks for all the amazing comments😍😍😍
--++--
Don't do drugs. And never mix pain and potion, fight your demons sober.
--++--
Kal kabhi nhi aata, jo bhi hai do itvright now. Don't judge and never keep regrets.
--++--
Take risk and be selfish
--++--
`;

const sep24 = `c,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,95,Ð„1339.5,23,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,Ungering (Bugfix),8696,Approved,323,03-September-2024,,,,1,AutoParti,8697,Approved,03-September-2024,1017,
2,Tractorpartsasap (Bugfix),8699,Approved,1015,03-September-2024,,,,2,Trupar,8779,Approved,05-September-2024,13107,
3,BdiExpress,8698,Approved,388,04-September-2024,,,,3,intellaliftparts,8776,Approved,05-September-2024,812,
4,OnlyMed Imaging Solutions,8695,Approved,273,04-September-2024,,,,4, Omnical US,8809,-,06-September-2024,524,
5,Printing Machine Parts,8754,Approved,998,05-September-2024,,,,5,Eastern Industrial Automation,8800,Approved,06-September-2024,1038,
6,Quick Time Online,8761,Approved,798,05-September-2024,,,,6,Ontrium,8820,Approved,06-September-2024,379,
7,Mosel-Elektro,8760,Approved,395,05-September-2024,,,,7,SMDV,8828,-,07-September-2024,176,
8,NewEgg JPN,8756,Approved,1045,05-September-2024,,,,8,Ayberg TUR,8834,Approved,08-September-2024,876,
9,Ebay Can,8774,-,977,05-September-2024,,,,9,Xonelec,8848,-,09-September-2024,309,
10,EBAY DEU,8775,Approved,844,05-September-2024,,,,10,Landefeld ITA,8849,-,09-September-2024,1138,
11,Stecker-Laden,8795,Approved,402,05-September-2024,,,,11,Get OEM Parts,8879,Approved,10-September-2024,1073,
12,CrowdComponents,8794,Approved,735,05-September-2024,,,,12,CarltonBates,8938,Approved,17-September-2024,1186,
13,All Around Industry Supply,8793,Approved,1094,05-September-2024,,,,13,Sklep Enexon,8953,Approved,18-September-2024,1203,
14,Source Atlantic,8788,Approved,1086,05-September-2024,,,,14,Huparts,8975,-,19-September-2024,1187,
15,Palmer's Electric Motors and Pumps,8786,Approved,1085,05-September-2024,,,,15,Paebra GMBH,8977,-,19-September-2024,1168,
16,Osd-Schenck,8784,Approved,698,05-September-2024,,,,16,PartsHawk,9024,Approved,22-September-2024,489,
17,Smc electric,8792,Approved,1087,05-September-2024,,,,17,ReMichel Co,9087,Approved,27-September-2024,1419,
18,RS Online DEU (Bugfix),8808,Approved,1042,06-September-2024,,,,18,Sid Harvey,9095,Approved,27-September-2024,1423,
19,Stoxxparts (Bugfix),8801,Approved,1039,06-September-2024,,,,19,Sigler,9091,Approved,27-September-2024,1420,
20,Dimeint (Bugfix),8821,Approved,265,06-September-2024,,,,20,Gustave A. Larson,9110,Approved,28-September-2024,1422,
21,Fkautomationshop,8813,Approved,235,06-September-2024,,,,21,Hajoca,9111,Approved,28-September-2024,1449,
22,Ehsy,8802,Approved,207,06-September-2024,,,,22,Johnson Supply,9119,Approved,29-September-2024,1432,
23,REIFF Technische Produkte,8811,Approved,743,06-September-2024,,,,23,Misumi ITA,9117,Approved,29-September-2024,1204,
24,DirectMed Imaging,8823,Approved,288,07-September-2024,,,,24,,,,,,
25,Acme Tools,8821,Approved,1037,07-September-2024,,,,25,,,,,,
26,Surplus Select,8819,Approved,1106,07-September-2024,,,,26,,,,,,
27,Reichelt AUT,8815,Approved,336,07-September-2024,,,,27,,,,,,
28,Elektrowelt-zwickau,8816,Approved,86,07-September-2024,,,,28,,,,,,
29,Mercateo (Bugfix),8830,Approved,851,07-September-2024,,,,29,,,,,,
30,Conrad CHE (Bugfix),8829,Approved,853,07-September-2024,,,,30,,,,,,
31,HVA Supply (Bugfix),8827,Approved,137,07-September-2024,,,,31,,,,,,
32,Conrad AUT,8832,Approved,850,08-September-2024,,,,32,,,,,,
33,Mercateo ,8830,Approved,851,08-September-2024,,,,33,,,,,,
34,Ozhat,8835,Approved,231,09-September-2024,,,,34,,,,,,
35,Reichelt,8859,Approved,296,10-September-2024,,,,35,,,,,,
36,Lektronix,8864,Approved,408,10-September-2024,,,,36,,,,,,
37,Go Glas,8860,Approved,256,10-September-2024,,,,37,,,,,,
38,Green Dealer,8857,Approved,1158,10-September-2024,,,,38,,,,,,
39,Automatica,8863,Approved,1062,10-September-2024,,,,39,,,,,,
40,Page Parts Gopher,8878,Approved,1164,10-September-2024,,,,40,,,,,,
41,IMS Supply,8867,Approved,985,12-September-2024,,,,41,,,,,,
42,UNITEC-D,8886,Approved,952,12-September-2024,,,,42,,,,,,
43,Radward,8887,Approved,937,12-September-2024,,,,43,,,,,,
44,Black Hawk Industrial',8888,Approved,963,12-September-2024,,,,44,,,,,,
45,Florida Parts Zone,8892,Approved,882,12-September-2024,,1304,,45,,,,,,
46,PBTECH,8126,Approved,14339,12-September-2024,,,,46,,,,,,
47,S4Spares,8065,Approved,14291,12-September-2024,,,,47,,,,,,
48, Schreiber & Kastelberger,8912,-,1175,12-September-2024,,,,48,,,,,,
49,IAS Components ESP,8914,Approved,1180,12-September-2024,,,,49,,,,,,
50,EU Automation,8915,Approved,1178,12-September-2024,,,,50,,,,,,
51,John Henry Foster,8928,Approved,525,15-September-2024,,,,51,,,,,,
52,SpareParts USA,8908,Approved,907,15-September-2024,,,,52,,,,,,
53,Future Electronics,8937,Approved,1191,17-September-2024,,,,53,,,,,,
54,EBAY Fra,8948,Approved,1248,18-September-2024,,,,54,,,,,,
55,EBAY Aut,8948,Approved,1246,18-September-2024,,,,55,,,,,,
56,EBAY Ita,8948,Approved,1247,18-September-2024,,,,56,,,,,,
57,Vekgro,8951,Approved,1231,18-September-2024,,,,57,,,,,,
58,Byens VVS,8950,Approved,1232,18-September-2024,,,,58,,,,,,
59,Etoh24,8949,Approved,1228,18-September-2024,,,,59,,,,,,
60,ready go parts,8961,Approved,64,18-September-2024,,,,60,,,,,,
61,Osiander,8954,Approved,885,18-September-2024,,,,61,,,,,,
62,Rothhas Online,8976,Approved,1167,19-September-2024,,,,62,,,,,,
63,BUY MACHINERY PARTS,8987,Approved,522,20-September-2024,,,,63,,,,,,
64,Tractor Supply Co,9000,Approved,434,20-September-2024,,,,64,,,,,,
65,Grainger,8999,Approved,1315,20-September-2024,,,,65,,,,,,
66,Global Parts Zone,8998,Approved,665,20-September-2024,,,,66,,,,,,
67, IFM DEU,9026,Approved,960,22-September-2024,,,,67,,,,,,
68,Bartsparts,9023,Approved,1205,22-September-2024,,,,68,,,,,,
69,Stecker Express,9025,-,1237,22-September-2024,,,,69,,,,,,
70,PARTS HVAC,9041,Approved,1267,23-September-2024,,,,70,,,,,,
71,Wiautomation,9040,Approved,1170,23-September-2024,,,,71,,,,,,
72,1001 Ersatzteile,9037,Approved,1280,23-September-2024,,,,72,,,,,,
73,Piecesauto24,9035,Approved,1342,23-September-2024,,,,73,,,,,,
74,LUTZ,9060,Approved,237,26-September-2024,,,,,,,,,,
75,Jensales,9074,-,686,26-September-2024,,,,,,,,,,
76,AC Pro,9088,Approved,1424,27-September-2024,,,,,,,,,,
77,American Metal Supply,9086,Approved,1430,27-September-2024,,,,,,,,,,
78,Auer Steel & Heating Supply Co.,9081,Approved,1427,27-September-2024,,,,,,,,,,
79,Hercules Industries Inc.,9082,Approved,1426,27-September-2024,,,,,,,,,,
80,Century A/C Supply,9084,Approved,1431,27-September-2024,,,,,,,,,,
81,APR Supply Co,9096,Approved,1433,27-September-2024,,,,,,,,,,
82,2J Supply HVAC Distributors,9106,Approved,1444,28-September-2024,,,,,,,,,,
83,Northeastern Supply Co.,9105,Approved,1446,28-September-2024,,,,,,,,,,
84,The Habegger,9098,-,1421,28-September-2024,,,,,,,,,,
85,(Johnstone Supply),9112,Approved,1450,28-September-2024,,,,,,,,,,
86, Crescent Parts & Equipment,9104,Approved,1445,28-September-2024,,,,,,,,,,
87,Win Supply,9109,Approved,1418,28-September-2024,,,,,,,,,,
88,Rothhaas Online,9118,Approved,1409,29-September-2024,,,,,,,,,,
89, Trane Supply,9133,Approved,1448,30-September-2024,,,,,,,,,,
90,HIW,9144,-,1453,30-September-2024,,,,,,,,,,
91,Reifftpshop,9139,-,1414,30-September-2024,,,,,,,,,,
92,DKL,9142,-,1454,30-September-2024,,,,,,,,,,
93,Mercateo AT,9141,-,849,30-September-2024,,,,,,,,,,
94,Wiautomation ITA,9140,-,1441,30-September-2024,,,,,,,,,,
95, eBay SGP,7916,-,14222,30-September-2024,,,,,,,,,,`;

const oct24 = `c,,,,,,PR TOTAL,TOTAL,PAGES IMPL,Pages Implemented,,,,,,
No.,Page,Pull Request,Status,Ticket Number,Date,87,Ð„1054.5,12,_No._,_Page_,_Pull Request_,_Status_,_Date_,_Ticket Number_,Comments
1,Granit Parts,9171,Approved,21,02-October-2024,,,,1,Carrier Commercial,9190,Approved,02-October-2024,1480,
2,Optiflex,9161,Approved,1458,02-October-2024,,,,2,Carrier Residential,9190,Approved,02-October-2024,1479,
3,M&A Supply Co. Inc.,9146,Approved,1443,02-October-2024,,,,3, Automatic Appliance Parts,9244,Approved,07-October-2024,1281,
4,LANTMAENNEN MASKIN,9176,Approved,294,03-October-2024,,,,4,HornBack,9270,Approved,08-October-2024,1503,
5,Parts Bobcat,9203,Approved,250,04-October-2024,,,,5,Druckluft_koenitzer,9290,Approved,10-October-2024,1518,
6,Web Parts,9198,Approved,1473,04-October-2024,,,,6,Druckluft Fachhandel,9293,Approved,10-October-2024,1515,
7,Defend Agro,9194,Approved,108,04-October-2024,,,,7,ElektronetShop AUT,9394,Approved,17-October-2024,3206,
8,hardy-schmitz,9215,Approved,222,05-October-2024,,,,8,RENISHAW GBR,9427,Approved,18-October-2024,5281,
9,Allied Controls,9205,Approved,233,05-October-2024,,,,9,RENISHAW DEU,9427,Approved,18-October-2024,5280,
10,Unielektro,9212,Approved,361,05-October-2024,,,,10,Acorn,9589,Approved,30-October-2024,5563,
11,Industrial Tools CAN,9213,Approved,199,05-October-2024,,,,11,FixParts Onlline,9622,Approved,31-October-2024,5569,
12,JC Tech-Electronics,9218,Approved,267,06-October-2024,,,,12,Page Printer Parts,9618,Approved,31-October-2024,5482,
13,Mitkco,9223,Approved,802,07-October-2024,,,,13,,,,,,
14,Automation24 AUT,9220,Approved,32,07-October-2024,,,,14,,,,,,
15,Elektromax24,9224,Approved,121,07-October-2024,,,,15,,,,,,
16,Lieske Industry Electronics,9245,Approved,1470,07-October-2024,,,,16,,,,,,
17,American Refrigeration Supplies,9243,Approved,643,07-October-2024,,,,17,,,,,,
18,FWWebb_Company,9242,Approved,722,07-October-2024,,,,18,,,,,,
19,WM Industrietechnik,9225,Approved,90,07-October-2024,,,,19,,,,,,
20,Southern Industrial & Truck LTD.,9230,Approved,501,07-October-2024,,,,20,,,,,,
21,Crossfilters,9228,Approved,540,07-October-2024,,,,21,,,,,,
22,Katiks,9227,Approved,394,07-October-2024,,,,22,,,,,,
23,Neyer,9249,Approved,813,08-October-2024,,,,23,,,,,,
24,(Indiana Industrial),9251,Approved,817,08-October-2024,,,,24,,,,,,
25,ElevatorKeys,9250,Approved,809,08-October-2024,,,,25,,,,,,
26,Greenheck,9268,Approved,708,08-October-2024,,,,26,,,,,,
27,Elanto24,9269,Approved,1504,08-October-2024,,,,27,,,,,,
28,2407pl,9271,Approved,591,09-October-2024,,,,28,,,,,,
29,SparePartsNow,9273,Approved,1526,09-October-2024,,,,29,,,,,,
30, eBay SGP,7916,Approved,14222,10-October-2024,,,,30,,,,,,
31,Automation Recovery,9282,Approved,1529,10-October-2024,,,,31,,,,,,
32,Roeco,9294,Approved,1551,10-October-2024,,,,32,,,,,,
33,Fkautomationshop,9295,Approved,1550,10-October-2024,,,,33,,,,,,
34,Machinery Trader USA,9296,Approved,1486,10-October-2024,,,,34,,,,,,
35,Logic,9292,Approved,1522,11-October-2024,,,,35,,,,,,
36, Rainbow Precision Products,9291,Approved,1524,11-October-2024,,,,36,,,,,,
37, Industrial Stores,9317,Approved,1557,13-October-2024,,,,37,,,,,,
38,Voomi Supply,9318,Approved,1553,13-October-2024,,,,38,,,,,,
39, Control Centeral,9319,Approved,1556,13-October-2024,,,,39,,,,,,
40,Ebay DEU,9395,Approved,1341,17-October-2024,,,,40,,,,,,
41,Renishaw USA,9427,Approved,5280,18-October-2024,,,,41,,,,,,
42,Amd Automation,9381,Approved,1539,20-October-2024,,,,42,,,,,,
43,More Control,9385,Approved,4128,20-October-2024,,,,43,,,,,,
44,Source Atlantic,9436,Approved,1525,21-October-2024,,,,44,,,,,,
45, Emac Stores,9452,Approved,1545,22-October-2024,,,,45,,,,,,
46,Ferguson,9453,Approved,1562,22-October-2024,,,,46,,,,,,
47,Loechel Industriebedarf,9483,Approved,3200,22-October-2024,,,,47,,,,,,
48,Pagus,9481,Approved,5322,22-October-2024,,,,48,,,,,,
49, Impexron DE,9482,Approved,4123,22-October-2024,,,,49,,,,,,
50,Bane-Welker Equipment,9450,Approved,5182,22-October-2024,,,,50,,,,,,
51,Partspring,9451,Approved,5025,22-October-2024,,,,51,,,,,,
52,JIT Truck Parts,9455,Approved,5047,22-October-2024,,,,52,,,,,,
53,PLC Direct,9471,Approved,1528,22-October-2024,,,,53,,,,,,
54, Oct-parts,9496,Approved,5486,23-October-2024,,,,54,,,,,,
55,Regro,9494,Approved,5488,23-October-2024,,,,55,,,,,,
56,TME DE,9507,Approved,5489,24-October-2024,,,,56,,,,,,
57,Elektro Wandelt,9505,Approved,5490,24-October-2024,,,,57,,,,,,
58,IAS Components,9522,Approved,5396,25-October-2024,,,,58,,,,,,
59,Service Asia,9521,Approved,1544,25-October-2024,,,,59,,,,,,
60,Leise,9519,Approved,5274,25-October-2024,,,,60,,,,,,
61,Ibf,9495,Approved,5299,25-October-2024,,,,61,,,,,,
62,EskaWelt,9534,Approved,5505,25-October-2024,,,,62,,,,,,
63,Druckluft-koenitzer,9536,Approved,5504,25-October-2024,,,,63,,,,,,
64,Kaufland,9539,Approved,5496,25-October-2024,,,,64,,,,,,
65,Maschinenteil24,9537,Approved,5503,25-October-2024,,,,65,,,,,,
66,Schreiber & Kastelberger,9535,Approved,5508,25-October-2024,,,,66,,,,,,
67,Ungering,9538,Approved,3203,25-October-2024,,,,67,,,,,,
68,Asendorf Hydraulik,9581,Approved,5516,30-October-2024,,,,68,,,,,,
69,Branom Instrument,9527,Approved,5473,30-October-2024,,,,69,,,,,,
70,Crusher Consumables Limited GBR,9579,Approved,5565,30-October-2024,,,,70,,,,,,
71,Global Parts Zone,9586,Approved,5568,30-October-2024,,,,71,,,,,,
72,SCG Supplies GBR,9587,Approved,5564,30-October-2024,,,,72,,,,,,
73,Bearing Boys,9588,Approved,5567,30-October-2024,,,,73,,,,,,
74, Lektronix DEU,9593,Approved,5555,30-October-2024,,,,,,,,,,
75,FB Tronics,9590,Approved,5559,30-October-2024,,,,,,,,,,
76,UNITEC-D,9591,Approved,5557,30-October-2024,,,,,,,,,,
77,JC Tech-Electronics,9597,Approved,5552,30-October-2024,,,,,,,,,,
78,BVS Electronics,9594,Approved,5554,30-October-2024,,,,,,,,,,
79,Computer Salg,9619,Approved,5446,31-October-2024,,,,,,,,,,
80,RSD Electronic,9639,Approved,5558,02-November-2024,,,,,,,,,,
81,Proshop AUT,9642,-,1169,02-November-2024,,,,,,,,,,
82,Unielektro,9640,Approved,5556,02-November-2024,,,,,,,,,,
83,NewEgg JPN,9641,Approved,1141,02-November-2024,,,,,,,,,,
84,John Henry Foster,9646,Approved,1497,02-November-2024,,,,,,,,,,
85,Locate Ball Bearings,9651,-,1527,03-November-2024,,,,,,,,,,
86,Wechselrichter Online,9653,Approved,5553,03-November-2024,,,,,,,,,,
87,Plc-City,9652,-,1543,03-November-2024,,,,,,,,,,
88,,,,,,,,,,,,,,,
89,,,,,,,,,,,,,,,
90,,,,,,,,,,,,,,,
91,,,,,,,,,,,,,,,
92,,,,,,,,,,,,,,,
93,,,,,,,,,,,,,,,
94,,,,,,,,,,,,,,,
95,,,,,,,,,,,,,,,
96,,,,,,,,,,,,,,,
97,,,,,,,,,,,,,,,
98,,,,,,,,,,,,,,,
99,,,,,,,,,,,,,,,
100,,,,,,,,,,,,,,,
101,,,,,,,,,,,,,,,
102,,,,,,,,,,,,,,,
103,,,,,,,,,,,,,,,
104,,,,,,,,,,,,,,,
105,,,,,,,,,,,,,,,
106,,,,,,,,,,,,,,,
107,,,,,,,,,,,,,,,
108,,,,,,,,,,,,,,,
109,,,,,,,,,,,,,,,
110,,,,,,,,,,,,,,,
111,,,,,,,,,,,,,,,
112,,,,,,,,,,,,,,,
113,,,,,,,,,,,,,,,
114,,,,,,,,,,,,,,,
115,,,,,,,,,,,,,,,
116,,,,,,,,,,,,,,,
117,,,,,,,,,,,,,,,
118,,,,,,,,,,,,,,,
119,,,,,,,,,,,,,,,
120,,,,,,,,,,,,,,,
121,,,,,,,,,,,,,,,
122,,,,,,,,,,,,,,,
123,,,,,,,,,,,,,,,
124,,,,,,,,,,,,,,,
125,,,,,,,,,,,,,,,
126,,,,,,,,,,,,,,,
127,,,,,,,,,,,,,,,
128,,,,,,,,,,,,,,,
129,,,,,,,,,,,,,,,
130,,,,,,,,,,,,,,,
131,,,,,,,,,,,,,,,
132,,,,,,,,,,,,,,,
133,,,,,,,,,,,,,,,
134,,,,,,,,,,,,,,,
135,,,,,,,,,,,,,,,
136,,,,,,,,,,,,,,,
137,,,,,,,,,,,,,,,
138,,,,,,,,,,,,,,,
139,,,,,,,,,,,,,,,
140,,,,,,,,,,,,,,,
141,,,,,,,,,,,,,,,
142,,,,,,,,,,,,,,,
143,,,,,,,,,,,,,,,
144,,,,,,,,,,,,,,,
145,,,,,,,,,,,,,,,
146,,,,,,,,,,,,,,,
147,,,,,,,,,,,,,,,
148,,,,,,,,,,,,,,,
149,,,,,,,,,,,,,,,
150,,,,,,,,,,,,,,,
151,,,,,,,,,,,,,,,
152,,,,,,,,,,,,,,,
153,,,,,,,,,,,,,,,
154,,,,,,,,,,,,,,,
155,,,,,,,,,,,,,,,
156,,,,,,,,,,,,,,,
157,,,,,,,,,,,,,,,
158,,,,,,,,,,,,,,,
159,,,,,,,,,,,,,,,
160,,,,,,,,,,,,,,,
161,,,,,,,,,,,,,,,`;

const nov24 = `None`

const monthsData = {
  "apr24": apr24,
  "may24": may24,
  "jun24": jun24,
  "jul24": jul24,
  "aug24": aug24,
  "sep24": sep24,
  "oct24": oct24,
  "nov": nov24,
  "advices": advices,
}

export default monthsData;